/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-lines */
//
declare global {
    interface Window {
        KDebug:any;
        kLNG:any;
        ks:any;
        $:any;
        jQuery:any;
    }
    interface Window {
        Phrases: string[];
    }
}

import LNG from "../ReUsableTS/kLNG";
import {kRequest} from "../ReUsableTS/kAjax";
import { SetCoreUtils, ICoreUtils } from "../kReusableCoreTS/kCoreHandler";
import { kObjectCore, kObjectArrayCore } from "../kReusableCoreTS/kCoreObjects";
import { kTimeCore } from "../kReusableCoreTS/kCoreTime";

// tslint:disable-next-line:no-any
/// <reference path="../ReUsableTS/JQuery.d.ts" />
//import jQuery from "../ReUsableTS/jquery-1.12.4.min.js";


import { kHTMLTable, kHTMLRow } from "../ReUsableTS/kHTML";
import { kModalDialog } from "../ReUsableTS/kModalDialog";
import { kNotification } from "../ReUsableTS/kNotifications";

export {kFileType, kFileTypeC, kFileTypes, kFile} from "./kFile";
if(undefined === window.KDebug){
    window.KDebug = {};
    window.KDebug.Phrases = [];
    window.KDebug.kLNG = LNG;
}

class kRegionalFormat {
    /** @description Date format */
    public df:string = "";
    /** @description Decimal separator */
    public dec = "";

    /** @description Thousand separator */
    public ts:string = "";

    /** @description First day of week*/
    public FDW:number = 0; //First day of week. 0 = Sunday, 1 = Monday

    //public cs: string; //Currency symbol
    //public sw: boolean; //Show
    public t12:boolean = false; //12 hour format
    public BC47:string ="";
    public curr:string = "";
}

class kDelayedAction {
    public CallBack:any = null;
    public Category = "";
    public Description = "";
    public MSSecondsDelay = 0;
    public ID = 0;
    public Parameters: any = null; // TODO: Define specific type when usage is known
    public Enabled = true;
}



export { kKeyValueCore as kKeyValue } from "../kReusableCoreTS/kCoreTime";
export { kObjectArrayCore } from "../kReusableCoreTS/kCoreObjects";
import { kKeyValueCore as kKeyValue } from "../kReusableCoreTS/kCoreTime";

export class kObject extends kObjectCore {
    // Browser-specific methods only — Title, ID, Index, UniqueID, constructor,
    // ToJSONObj, FromSaved, CloneObject are inherited from kObjectCore.

    public ShowProgress = (
        ProgressMessage: string,
        Done: number,
        Total: number
    ): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            ks.ShowNotification(
                ProgressMessage + " " + Done.toString() + "/" + Total.toString()
            );
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kObject.ToRow");
            return;
        }
    };
    public ToRow = (): HTMLTableRowElement | null => {
        if (ks.kErrorMode === true) {return null;}
        try {
            const Row: kHTMLRow = new kHTMLRow();
            Row.AddCell(ks.nz(this.Title));
            return Row.Row;
        } catch (e) {ks.kGlobalErrorHandler(e, "kObject.ToRow");return null;}
    };
    public FromRow = (CurrRow: kHTMLRow): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            CurrRow.GetCells();
            if (CurrRow.Cells.length === 1) {
                this.Title = ks.nz(CurrRow.Cells[0].textContent).trim();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kObject.FromRow");
        }
    };
    public ToAnchor = (): HTMLAnchorElement  => {
        const Anchor: HTMLAnchorElement = document.createElement("a");
        if (ks.kErrorMode === true) {return Anchor;};
        try {
            Anchor.textContent = ks.nz(this.Title);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kObject.ToAnchor");
        }
        return Anchor;
    }
}
export class kObjectArray extends kObjectArrayCore {
    // Items and NewItem inherited from kObjectArrayCore as kObjectCore[]
    // Do NOT override with kObject[] — it breaks subclasses whose items extend kObjectCore via core chains
    // Inherited from kObjectArrayCore: Items, NewItem, ExtendedClass,
    // push, RemoveItemByIndex, RemoveItemByTitle, RemoveItemByUniqueID,
    // RemoveItemByID, GetItemByTitle, GetOrAddByTitle, GetItemByUniqueID,
    // GetItemByID, GetRandomItem, SortByTitle, SortByProperty,
    // SortAndRemoveDoubles, RemoveTitleDoubles, ToTitlesArray,
    // ToPersistedArray, FromPersistedArray, FromTitlesArray

    // Browser-specific override: uses ks.AddDelayedAction instead of setTimeout,
    // and calls ShowProgress on items for UI feedback.
    // eslint-disable-next-line @typescript-eslint/ban-types
    public CallFunctionOnEach = (
        FunctionName: any,
        AllDone: any,
        ObjectName?: any,
        StartIndex?: number,
        ProgressMessage?: string,
        ProgressCallback?: any,
        Parameter?:any
    ): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            this._ObjectName = ks.nz(ObjectName);
            this._FunctionName = FunctionName;
            this._ActionDoneCallback = AllDone;
            this._ForEachPar = Parameter;
            if (ProgressCallback) {
                this._ProgressCB = ProgressCallback;
            }
            if (ks.kNotNullOrUndefined(StartIndex)) {
                this._ActionCounter = ks.n0(StartIndex);
            } else {
                this._ActionCounter = 0;
            }
            this._ProgressMessage = ks.nz(ProgressMessage);
            this._NextCallback();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kObjectArray.CallFunctionOnEach");
        }
    };
    protected _NextCallback = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (this._ActionCounter < this.Items.length) {
                this._ActionCounter++;
                if (this._ProgressCB) {
                    this._ProgressCB(
                        this._ProgressMessage,
                        this._ActionCounter,
                        this.Items.length
                    );
                } else {
                    if (ks.kNotEmptyString(this._ProgressMessage)) {
                        (this.Items[this._ActionCounter - 1] as kObject).ShowProgress(
                            this._ProgressMessage,
                            this._ActionCounter,
                            this.Items.length
                        );
                    }
                }
                const currentItem = this.Items[this._ActionCounter - 1] as any; // Cast to any for dynamic property access
                if (ks.kNotEmptyString(this._ObjectName)) {
                    ks.AddDelayedAction("Avoid call stack issues",currentItem[this._ObjectName][this._FunctionName],"",5,this._NextCallback);
                } else {
                    ks.AddDelayedAction("Avoid call stack issues",currentItem[this._FunctionName],"",5,this._NextCallback);
                }
            } else {
                ks.DoCallBack(this._ActionDoneCallback);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kObjectArray._NextCallback");
        }
    };

    // Browser-specific methods (DOM/HTML operations)
    public ToTableObject = (): kHTMLTable => {
        if (ks.kErrorMode === true) {return new kHTMLTable();}
        try {
            const RenderingTable: kHTMLTable = new kHTMLTable();
            for (const CurrItem of this.Items) {
                RenderingTable.AddRowObject(<HTMLTableRowElement>(CurrItem as any as kObject).ToRow());
            }
            return RenderingTable;
        } catch (e) {ks.kGlobalErrorHandler(e, "kObjectArray.ToTableObject");return new kHTMLTable();}
    };
    public ToTable = (): HTMLTableElement => {
        if (ks.kErrorMode === true) {
            return document.createElement("table");
        }
        try {
            const TableObj: kHTMLTable | null = this.ToTableObject();
            if (null !== TableObj) {
                return TableObj.Table;
            }
            return document.createElement("table");
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kObjectArray.ToTable");
            return document.createElement("table");
        }
    };
    public ToTableString = (WithCSS?:boolean): string => {
        let ReturnString: string = "";
        if (ks.kErrorMode === true) {
            return "";
        }
        try {

            if (this.Items.length > 0) {
                const TableObj: kHTMLTable | null = this.ToTableObject();
                if(WithCSS === true) {
                    ReturnString += "<style>";
                    ReturnString += kHTMLTable.GetStyle();
                    ReturnString += "</style>";
                }
                if (null !== TableObj) {
                    ReturnString += TableObj.Table.outerHTML;
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kObjectArray.ToTableString");
        }
        return ReturnString;
    };
    public FromTable = (TableHTML: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            const RenderingTable: kHTMLTable = new kHTMLTable();
            this.Items = [];
            if (ks.kNotEmptyHTML(TableHTML)) {
                RenderingTable.FromString(TableHTML);
                RenderingTable.getRows();
                for (const CurrRow of RenderingTable.Rows) {
                    const NewObject: kObject = new this.NewItem() as any as kObject;
                    if (null !== NewObject) {
                        NewObject.FromRow(CurrRow);
                        if (ks.kNotNullOrUndefined(NewObject.ID)) {
                            NewObject.ID = this.Items.length;
                        }
                        this.push(NewObject);
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kObjectArray.FromTable");
        }
    };
}
class kTimer extends kObject {
    constructor() {
        super();
        this.StartTime = new Date().getTime();
    }
    public StartTime = 0;
    public Ended = false;
    public ElapsedTime = -1;
    public UpdateElapsedTime = (): void => {
        const CurrTime: number = new Date().getTime();
        this.ElapsedTime = CurrTime - this.StartTime;
    };
    public ToString = (): string => {
        if (this.Ended === false) {
            this.UpdateElapsedTime();
        }
        return this.Title + ": " + this.ElapsedTime + " ms\n";
    };
    public EndTimer = (): void => {
        if (this.Ended === false) {
            this.UpdateElapsedTime();
            this.Ended = true;
        }
    };
    public PrintToLog = (): void => {
        ks.colorLog(this.ToString(), "blue");
    };
    public EndAndLog = (): number => {
        this.EndTimer();
        this.PrintToLog();
        return this.ElapsedTime;
    };
}
class kTimers extends kObjectArray {
    public Items: kTimer[] = [];
    public AddTimer = (Title: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            let CurrTimer: kTimer | null = null;
            let ExistingTimer: kTimer | null = null;
            ExistingTimer = this.GetItemByTitle(Title);
            if (ExistingTimer !== null) {
                CurrTimer = ExistingTimer;
            } else {
                CurrTimer = new kTimer();
                CurrTimer.Title = Title;
                this.push(CurrTimer);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kTimers.AddTimer");
        }
    };
    public EndTimer = (Title: string): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            const Timer: kTimer | null = this.GetItemByTitle(Title);
            if (Timer !== null) {
                return Timer.EndAndLog();
            }
            return 0;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kTimers.EndTimer");
            return 0;
        }
    };
    public EndAllTimers = (): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            let Timer: kTimer;
            for (Timer of this.Items) {
                if (Timer.Ended === false) {
                    Timer.EndAndLog();
                }
            }
            this.Items = [];
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kTimers.EndAllTimers");
        }
    };
}
export class kBoolean {
    public Value = false;
    public ID = "";
    public Caption = "";

    public constructor(ID: string, Value: boolean) {
        this.ID = ID;
        this.Value = Value;
    }

    public ToElements = (ParentObj: HTMLElement, Caption: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            const DivContainer: HTMLDivElement = document.createElement("div");
            const HTMLCheckbox: HTMLInputElement =
                document.createElement("input");
            HTMLCheckbox.type = "checkbox";
            HTMLCheckbox.id = this.ID;
            if (this.Value) {
                HTMLCheckbox.setAttribute("checked", "checked");
            }
            HTMLCheckbox.name = this.ID;
            HTMLCheckbox.value = this.ID;
            DivContainer.appendChild(HTMLCheckbox);

            const Label: HTMLLabelElement = document.createElement("label");
            Label.htmlFor = this.ID;
            Label.textContent = Caption;
            DivContainer.appendChild(Label);
            ParentObj.appendChild(DivContainer);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kBoolean.ToElements");
        }
    };
    public FromElements = (Doc?: Document): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (!ks.kNotNullOrUndefined(Doc)) {
                Doc = document;
            }
            if (undefined !== Doc) {
                const HTMLCheckbox: HTMLInputElement = Doc.getElementById(
                    this.ID
                ) as HTMLInputElement;
                if (ks.kNotNullOrUndefined(HTMLCheckbox)) {
                    this.Value = HTMLCheckbox.checked;
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kBoolean.FromElements");
        }
    };
}

export { kWorkPeriodCore as kWorkPeriod } from "../kReusableCoreTS/kCoreTime";

export class kTime extends kTimeCore {
    // Inherited from kTimeCore: Year, Month, Day, Hour, Minute, Second, MilliSecond,
    // IsValid (defaults to false), isBefore, isWeekend, IsToday, DaysToOtherDate,
    // SetTimeToBeginningOfDay, SetTimeToEndOfDay, SetTimeFromString,
    // SetTimeToBeginningOfWeek, SetTimeToEndOfWeek, SetDayToFirstOfMonth,
    // SetDayToLastOfMonth, SetToNow, Add, AddDays, AddMinutes, SubractMinutes,
    // SubractDays, ToJsDate, TreatAsUTC, fromJSDate, fromISO, FromISODate,
    // FromISODateTime, FromJSON, FromSPFXDate, ToISODate, ToISOTime,
    // ToISODateTime, ToISODateTimeSecs, To2DigitTime, Weekday, WeekNumber,
    // YearWeekNumber, MSecsFromNow, SecondsFromNow, SecsFromNow, MinutesFromNow

    // Browser-specific overrides: use navigator.languages[0] instead of serverLocale()
    public WeekdayName = (): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if(this.IsValid){
                const CurrDate: Date = this.ToJsDate();
                return CurrDate.toLocaleDateString(navigator.languages[0], {
                    weekday: "long"
                });
            }else{
                return "";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kTime.Weekday");
            return "";
        }
    };
    public WeekDayName2 = (): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if(this.IsValid){
                const CurrDate: Date = this.ToJsDate();
                const ShortWeekdayName:string = CurrDate.toLocaleDateString(navigator.languages[0], {weekday: "short"});
                return (ShortWeekdayName.substring(0,1).toUpperCase() + ShortWeekdayName.substring(1,2));
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kTime.WeekDayName2");
        }
        return "";

    };
    public MonthName = (): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            const CurrDate: Date = this.ToJsDate();
            return CurrDate.toLocaleDateString(navigator.languages[0], {
                month: "long",
            });
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kTime.MonthName");
            return "";
        }
    };

    // Browser-specific override: preserves TimeZoneBias parameter for API compatibility
    public FromSPDate = (SPDate: string, AllDay?: boolean,TimeZoneBias?:number): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (!SPDate) {
                this.IsValid = false;
                return;
            }
            if (AllDay === true) {
                SPDate = SPDate.replace("T", " ").replace("Z", "");
            }
            const NewTimeJSDate: Date = new Date(SPDate);
            if (ks.kNotNullOrUndefined(NewTimeJSDate)) {
                this.fromJSDate(NewTimeJSDate);
                // if(TimeZoneBias){
                //     this.AddMinutes(TimeZoneBias + NewTimeJSDate.getTimezoneOffset());
                // }
            } else {
                this.IsValid = false;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kTime.FromSPDate");
        }
    };

    // Browser-specific override: clone returns browser kTime (not core kTime)
    public clone = (): kTime => {
        if (ks.kErrorMode === true) {
            return new kTime();
        }
        try {
            const NewTime: kTime = new kTime();
            NewTime.Year = this.Year;
            NewTime.Month = this.Month;
            NewTime.Day = this.Day;
            NewTime.Hour = this.Hour;
            NewTime.Minute = this.Minute;
            NewTime.Second = this.Second;
            NewTime.MilliSecond = this.MilliSecond;
            NewTime.IsValid = this.IsValid;
            return NewTime;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kTime.clone");
            return new kTime();
        }
    };

    // Browser-specific override: uses ks.NumberandDateFormat.df for regional formatting
    public ToLocalShortDate = (): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            let CurrDateFormat = "yyyy-MM-dd";
            let CurrDateString = "";
            try {
                if (null !== ks.NumberandDateFormat) {
                    CurrDateFormat = ks.NumberandDateFormat.df;
                }
            } catch {
                //Ignore this error
            }
            if (this.Year > 1970) {
                CurrDateFormat = CurrDateFormat.toLowerCase();
                CurrDateString = CurrDateFormat.replace(
                    "yyyy",
                    this.Year.toString()
                );

                CurrDateString = CurrDateString.replace(
                    "mm",
                    ("0" + this.Month.toString()).slice(-2)
                );
                CurrDateString = CurrDateString.replace(
                    "m",
                    this.Month.toString()
                );

                CurrDateString = CurrDateString.replace(
                    "dd",
                    ("0" + this.Day.toString()).slice(-2)
                );
                CurrDateString = CurrDateString.replace(
                    "d",
                    this.Day.toString()
                );
            }
            return CurrDateString;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kTime.ToLocalShortDate");
            return "";
        }
    };
    public ToLocalShortDateAndTime = (): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if (this.Year > 1969) {
                return (
                    this.ToLocalShortDate() +
                    " " +
                    this.ToJsDate().toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                    })
                );
            } else {
                return "";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kTime.ToLocalShortDate");
            return "";
        }
    };
}
export default class ks {
    public static LNG:any = {};
    //public static SupportedFileTypes: kFileTypes = new kFileTypes();
    public static $: any =null;

    public static kDebugMode = false;
    public static kTimers: kTimers  = new kTimers();
    public static NumberandDateFormat: kRegionalFormat | null = null;
    public static kErrorMode = false;
    public static kShowingErrorDialog = false;

    // Toggle: set ONE of these to true to control error reporting target
    public static ReportToKalmstrom = true;
    public static ReportToBoostly = false;

    private static kServicesURLKalmstrom =
        "https://defaultc5c9daeae0b843bdb799a266cb2475.a0.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/8ab3a75b5c08477d89454ae2dc7dfea0/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=_FxDVAGWnG4e6gexgHD3QbV4HstupGP_1fC1vNGzIXg";
    private static kServicesURLBoostly =
        "https://default7adf5b26cafd4b468d51207d7c9e2b.da.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/c30fd8194a42418982963220a58a253a/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=f9_6BL9OSCjys9fGVDj1cro8C7JHU7sqqVk2ooNid6k";
    //"https://kalmstromregistration.azurewebsites.net/api/ReportError/jsonp?callback=?";
    //public static kServicesURL: string = "http://localhost:60286/api/ReportError/jsonp?callback=?";

    public static get kServicesURL(): string {
        return ks.ReportToBoostly ? ks.kServicesURLBoostly : ks.kServicesURLKalmstrom;
    }
    public static get kSupportEmail(): string {
        return ks.ReportToBoostly ? "peter@boostly.digital" : "support@kalmstrom.com";
    }
    public static get kReportTargetName(): string {
        return ks.ReportToBoostly ? "Boostly Digital" : "kalmstrom.com";
    }

    public static ErrorTriggered = false;


    private static _ConfirmCurrentData: any = null;

    public static _localeDateFormat: any[] = [
        {'BC47': 'af-za', 'LCID': 1078, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'ZAR'},
        {'BC47': 'lb-lu', 'LCID': 1134, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'RWF'},
        {'BC47': 'ibb-ng', 'LCID': 1129, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'NGN'},
        {'BC47': 'id-id', 'LCID': 1057, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'IDR'},
        {'BC47': 'ig-ng', 'LCID': 1136, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'NGN'},
        {'BC47': 'is-is', 'LCID': 1039, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'ISK'},
        {'BC47': 'it-ch', 'LCID': 2064, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'it-it', 'LCID': 1040, 'FDW': 1, 'df': 'dd/MM/yyyy', 'dec': ',', 'ts': '.', 'curr': 'EUR'},
        {'BC47': 'ja-jp', 'LCID': 1041, 'FDW': 0, 'df': 'yyyy/MM/dd', 'dec': '.', 'ts': ',', 'curr': 'JPY'},
        {'BC47': 'kl-gl', 'LCID': 1135, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'XAF'},
        {'BC47': 'ko-kr', 'LCID': 1042, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'KRW'},
        {'BC47': 'ky-kg', 'LCID': 1088, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'KGS'},
        {'BC47': 'lt-lt', 'LCID': 1063, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-be', 'LCID': 2060, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'lv-lv', 'LCID': 1062, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'mk-mk', 'LCID': 1071, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'MKD'},
        {'BC47': 'mn-mn', 'LCID': 1104, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'MZN'},
        {'BC47': 'moh-ca', 'LCID': 1148, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'ms-bn', 'LCID': 2110, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'ms-my', 'LCID': 1086, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'DZD'},
        {'BC47': 'nb-no', 'LCID': 1044, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'NOK'},
        {'BC47': 'nl-be', 'LCID': 2067, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'nl-nl', 'LCID': 1043, 'FDW': 1, 'df': 'dd-MM-yyyy', 'dec': ',', 'ts': '.', 'curr': 'EUR'},
        {'BC47': 'nn-no', 'LCID': 2068, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'NOK'},
        {'BC47': 'ar-ae', 'LCID': 14337, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AED'},
        {'BC47': 'hu-hu', 'LCID': 1038, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'HUF'},
        {'BC47': 'hsb-de', 'LCID': 1070, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'hr-hr', 'LCID': 1050, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-cd', 'LCID': 9228, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-ch', 'LCID': 4108, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-ci', 'LCID': 12300, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-cm', 'LCID': 11276, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-fr', 'LCID': 1036, 'FDW': 1, 'df': 'dd/MM/yyyy', 'dec': ',', 'ts': ' ', 'curr': 'EUR'},
        {'BC47': 'fr-ht', 'LCID': 15372, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-lu', 'LCID': 5132, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-ma', 'LCID': 14348, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-mc', 'LCID': 6156, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-ml', 'LCID': 13324, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-re', 'LCID': 8204, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fr-sn', 'LCID': 10252, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fy-nl', 'LCID': 1122, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'ga-ie', 'LCID': 2108, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'gd-gb', 'LCID': 1169, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'GBP'},
        {'BC47': 'gl-es', 'LCID': 1110, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'gn-py', 'LCID': 1140, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'UGX'},
        {'BC47': 'gsw-fr', 'LCID': 1156, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'haw-us', 'LCID': 1141, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'ZMW'},
        {'BC47': 'he-il', 'LCID': 1037, 'FDW': 0, 'df': 'dd/MM/yyyy', 'dec': '.', 'ts': ',', 'curr': 'ILS'},
        {'BC47': 'hr-ba', 'LCID': 4122, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'BAM'},
        {'BC47': 'nso-za', 'LCID': 1132, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'BWP'},
        {'BC47': 'oc-fr', 'LCID': 1154, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'pl-pl', 'LCID': 1045, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'PLN'},
        {'BC47': 'sq-al', 'LCID': 1052, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'ALL'},
        {'BC47': 'sv-se', 'LCID': 1053, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': ',', 'ts': ' ', 'curr': 'SEK'},
        {'BC47': 'sw-ke', 'LCID': 1089, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'GBP'},
        {'BC47': 'th-th', 'LCID': 1054, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'THB'},
        {'BC47': 'tk-tm', 'LCID': 1090, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'PKR'},
        {'BC47': 'tn-bw', 'LCID': 2098, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'ZAR'},
        {'BC47': 'tn-za', 'LCID': 1074, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'MGA'},
        {'BC47': 'tr-tr', 'LCID': 1055, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'TRY'},
        {'BC47': 'tt-ru', 'LCID': 1092, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'TZS'},
        {'BC47': 'ug-cn', 'LCID': 1152, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'uk-ua', 'LCID': 1058, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'UAH'},
        {'BC47': 'ur-in', 'LCID': 2080, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'PKR'},
        {'BC47': 'ur-pk', 'LCID': 1056, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'PKR'},
        {'BC47': 'vi-vn', 'LCID': 1066, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'VND'},
        {'BC47': 'wo-sn', 'LCID': 1160, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'xh-za', 'LCID': 1076, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'MWK'},
        {'BC47': 'yo-ng', 'LCID': 1130, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'NGN'},
        {'BC47': 'zh-cn', 'LCID': 2052, 'FDW': 1, 'df': 'yyyy/M/d', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'zh-hk', 'LCID': 3076, 'FDW': 0, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'HKD'},
        {'BC47': 'zh-mo', 'LCID': 5124, 'FDW': 0, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'MOP'},
        {'BC47': 'zh-sg', 'LCID': 4100, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'zh-tw', 'LCID': 1028, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'TWD'},
        {'BC47': 'sv-fi', 'LCID': 2077, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'SEK'},
        {'BC47': 'sms-fi', 'LCID': 8251, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'prs-af', 'LCID': 1164, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AFN'},
        {'BC47': 'smn-fi', 'LCID': 9275, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'pt-br', 'LCID': 1046, 'FDW': 1, 'df': 'dd/MM/yyyy', 'dec': ',', 'ts': '.', 'curr': 'BRL'},
        {'BC47': 'pt-pt', 'LCID': 2070, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'quz-bo', 'LCID': 1131, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'GHS'},
        {'BC47': 'quz-ec', 'LCID': 2155, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'quz-pe', 'LCID': 3179, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'rm-ch', 'LCID': 1047, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'ro-md', 'LCID': 2072, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'RON'},
        {'BC47': 'ro-ro', 'LCID': 1048, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'HUF'},
        {'BC47': 'ru-md', 'LCID': 2073, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'RUB'},
        {'BC47': 'ru-ru', 'LCID': 1049, 'FDW': 1, 'df': 'dd.MM.yyyy', 'dec': ',', 'ts': ' ', 'curr': 'RUB'},
        {'BC47': 'rw-rw', 'LCID': 1159, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'RWF'},
        {'BC47': 'sah-ru', 'LCID': 1157, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'RUB'},
        {'BC47': 'se-fi', 'LCID': 3131, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'se-no', 'LCID': 1083, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'se-se', 'LCID': 2107, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'SEK'},
        {'BC47': 'sk-sk', 'LCID': 1051, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'sl-si', 'LCID': 1060, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'sma-no', 'LCID': 6203, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'SEK'},
        {'BC47': 'sma-se', 'LCID': 7227, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'SEK'},
        {'BC47': 'smj-no', 'LCID': 4155, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'SEK'},
        {'BC47': 'smj-se', 'LCID': 5179, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'SEK'},
        {'BC47': 'fr-ca', 'LCID': 3084, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'zu-za', 'LCID': 1077, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'ZAR'},
        {'BC47': 'de-li', 'LCID': 5127, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'ar-kw', 'LCID': 13313, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'KWD'},
        {'BC47': 'ar-qa', 'LCID': 16385, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'SYP'},
        {'BC47': 'en-au', 'LCID': 3081, 'FDW': 0, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AUD'},
        {'BC47': 'ar-om', 'LCID': 8193, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'OMR'},
        {'BC47': 'en-bz', 'LCID': 10249, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'en-ca', 'LCID': 4105, 'FDW': 0, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CAD'},
        {'BC47': 'en-gb', 'LCID': 2057, 'FDW': 1, 'df': 'dd/MM/yyyy', 'dec': '.', 'ts': ',', 'curr': 'GBP'},
        {'BC47': 'en-hk', 'LCID': 15369, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'en-id', 'LCID': 14345, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'en-ie', 'LCID': 6153, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'en-in', 'LCID': 16393, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'en-jm', 'LCID': 8201, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'en-my', 'LCID': 17417, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'en-nz', 'LCID': 5129, 'FDW': 0, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'NZD'},
        {'BC47': 'ar-ly', 'LCID': 4097, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'LYD'},
        {'BC47': 'en-ph', 'LCID': 13321, 'FDW': 0, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'en-sg', 'LCID': 18441, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'en-tt', 'LCID': 11273, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'en-us', 'LCID': 1033, 'FDW': 0, 'df': 'M/d/yyyy', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'en-za', 'LCID': 7177, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'ar-sa', 'LCID': 1025, 'FDW': 0, 'df': 'dd/MM/yy', 'dec': 'Ù«', 'ts': 'Ù¬', 'curr': 'SAR'},
        {'BC47': 'el-gr', 'LCID': 1032, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'dsb-de', 'LCID': 2094, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'ar-ye', 'LCID': 9217, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'QAR'},
        {'BC47': 'be-by', 'LCID': 1059, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'BYN'},
        {'BC47': 'bg-bg', 'LCID': 1026, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'BGN'},
        {'BC47': 'ba-ru', 'LCID': 1133, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'RUB'},
        {'BC47': 'bin-ng', 'LCID': 1126, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'NGN'},
        {'BC47': 'br-fr', 'LCID': 1150, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'PYG'},
        {'BC47': 'ca-es', 'LCID': 1027, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'arn-cl', 'LCID': 1146, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CLP'},
        {'BC47': 'co-fr', 'LCID': 1155, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'cs-cz', 'LCID': 1029, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CZK'},
        {'BC47': 'ar-sy', 'LCID': 10241, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'TND'},
        {'BC47': 'ar-tn', 'LCID': 7169, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'YER'},
        {'BC47': 'cy-gb', 'LCID': 1106, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'NGN'},
        {'BC47': 'da-dk', 'LCID': 1030, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': ',', 'ts': '.', 'curr': 'DKK'},
        {'BC47': 'de-at', 'LCID': 3079, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'de-ch', 'LCID': 2055, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'de-de', 'LCID': 1031, 'FDW': 1, 'df': 'dd.MM.yyyy', 'dec': ',', 'ts': '.', 'curr': 'EUR'},
        {'BC47': 'fo-fo', 'LCID': 1080, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'DKK'},
        {'BC47': 'de-lu', 'LCID': 4103, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'ar-lb', 'LCID': 12289, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'LBP'},
        {'BC47': 'ar-ma', 'LCID': 6145, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'MAD'},
        {'BC47': 'ar-jo', 'LCID': 11265, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'JOD'},
        {'BC47': 'fa-ir', 'LCID': 1065, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'IRR'},
        {'BC47': 'ar-bh', 'LCID': 15361, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'BHD'},
        {'BC47': 'et-ee', 'LCID': 1061, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-gt', 'LCID': 4106, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-hn', 'LCID': 18442, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-mx', 'LCID': 2058, 'FDW': 0, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-ni', 'LCID': 19466, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'ar-dz', 'LCID': 5121, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'DZD'},
        {'BC47': 'eu-es', 'LCID': 1069, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-es', 'LCID': 3082, 'FDW': 1, 'df': 'dd/MM/yyyy', 'dec': ',', 'ts': '.', 'curr': 'EUR'},
        {'BC47': 'es-pa', 'LCID': 6154, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-pe', 'LCID': 10250, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-pr', 'LCID': 20490, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-py', 'LCID': 15370, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-sv', 'LCID': 17418, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-us', 'LCID': 21514, 'FDW': 0, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-uy', 'LCID': 14346, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'ar-eg', 'LCID': 3073, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EGP'},
        {'BC47': 'es-ve', 'LCID': 8202, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-co', 'LCID': 9226, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-cr', 'LCID': 5130, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-bo', 'LCID': 16394, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-ar', 'LCID': 11274, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fi-fi', 'LCID': 1035, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': ',', 'ts': ' ', 'curr': 'EUR'},
        {'BC47': 'es-cl', 'LCID': 13322, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'fil-ph', 'LCID': 1124, 'FDW': 0, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'ar-iq', 'LCID': 2049, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'IQD'},
        {'BC47': 'es-cu', 'LCID': 23562, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'es-do', 'LCID': 7178, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'en-zw', 'LCID': 12297, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'es-ec', 'LCID': 12298, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'zh-tw_radstr', 'LCID': 263172, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'sr-latn-ba', 'LCID': 6170, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'sr-latn-me', 'LCID': 11290, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'zh-tw_pronun', 'LCID': 197636, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'az-cyrl', 'LCID': 2092, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'sr-latn-rs', 'LCID': 9242, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'zh-sg_stroke', 'LCID': 135172, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'tg-cyrl-tj', 'LCID': 1064, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'az-latn', 'LCID': 1068, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'tzm-latn', 'LCID': 2143, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'uz-latn', 'LCID': 1091, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'},
        {'BC47': 'x-iv_mathan', 'LCID': 65663, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'ZAR'},
        {'BC47': 'zh-cn_stroke', 'LCID': 133124, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'sr-cyrl-rs', 'LCID': 10266, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'zh-hk_radstr', 'LCID': 265220, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'uz-cyrl-uz', 'LCID': 2115, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'zh-sg_phoneb', 'LCID': 331780, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'zh-mo_radstr', 'LCID': 267268, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'zh-mo_stroke', 'LCID': 136196, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'zh-cn_phoneb', 'LCID': 329732, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CNY'},
        {'BC47': 'tzm-arab-ma', 'LCID': 1119, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'MAD'},
        {'BC47': 'fr-029', 'LCID': 7180, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'sr-cyrl-me', 'LCID': 12314, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'iu-latn-ca', 'LCID': 2141, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'CAD'},
        {'BC47': 'la-001', 'LCID': 1142, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'GNF'},
        {'BC47': 'ku-arab-iq', 'LCID': 1170, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'IQD'},
        {'BC47': 'kr-latn-ng', 'LCID': 1137, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'es-419', 'LCID': 22538, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'ja-jp_radstr', 'LCID': 263185, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'JPY'},
        {'BC47': 'pa-arab-pk', 'LCID': 2118, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'PKR'},
        {'BC47': 'hu-hu_technl', 'LCID': 66574, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'HUF'},
        {'BC47': 'es-es_tradnl', 'LCID': 1034, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'ha-latn-ng', 'LCID': 1128, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'ff-latn', 'LCID': 2151, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'ff-latn-ng', 'LCID': 1127, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'pap', 'LCID': 1145, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'MGA'},
        {'BC47': 'sr-cyrl-ba', 'LCID': 7194, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'ca-es-valencia', 'LCID': 2051, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'bs-cyrl', 'LCID': 8218, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'bs-latn', 'LCID': 5146, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'AZN'},
        {'BC47': 'sd-arab-pk', 'LCID': 2137, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'PKR'},
        {'BC47': 'de-de_phoneb', 'LCID': 66567, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'quc-latn-gt', 'LCID': 1158, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'EUR'},
        {'BC47': 'en-029', 'LCID': 9225, 'FDW': 1, 'df': 'yyyy-MM-dd', 'dec': '.', 'ts': ',', 'curr': 'USD'}

    ];

    public static UserLanguage = "en";
    public static UserLanguageLong = "en-us";
    public static UserLanguageName = "English";

    public static excelServerURL = "";
    public static Extraparameters = "";

    public static LocalStorageLimit = 100000;
    public static kDelayedActions: kDelayedAction[] = [];
    public static kNotification: any = null;
   public static enumAppType: any = {
        HTML: 1,
        Sandbox: 2,
        SPAddin: 3,
        SPAddinPart: 4,
        SPFX: 5,
        SPTeams: 6,
    };
    public static kApplication: any = {
        IsSharepointVersion: false,
        version: "",
        name: "",
        shortname: "",
        LCID: 0, //used when the application should NOT detect language from the regional settings
        apptype:ks.enumAppType.sandbox,
    };

    public static UserObject: any = {
        ID: "",
        Name: "",
        Email: "",
        LoginName: "",
        IsSiteAdmin: false,
        PictureUrl: "",
        JobTitle: "",
        Phone: "",
    };
    public static ErrorDetails: any = {
        FunctionName: "",
        Message: "",
        LineNumber: 0,
        ErrorFile: "",
    };
    public static colorLog = (message: string, color: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            color = color || "black";

            switch (color) {
                case "success":
                    color = "Green";
                    break;
                case "info":
                    color = "DodgerBlue";
                    break;
                case "error":
                    color = "Red";
                    break;
                case "warning":
                    color = "Orange";
                    break;
                default:
            }
            console.log("%c" + message, "color:" + color);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.colorLog");
        }
    };

    public static ArrayMove = (
        arr: any[],
        old_index: number,
        new_index: number
    ) => {
        if (ks.kErrorMode === true) {
            return false;
        }
        try {
            if (new_index >= arr.length) {
                let k = new_index - arr.length + 1;
                while (k--) {
                    arr.push(undefined);
                }
            }
            arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.ArrayMove");
            return false;
        }
    };
    public static equals = (a: any, b: any): boolean => {
        if (ks.kErrorMode === true) {
            return false;
        }
        try {
            if (a === b) return true;

            if (a instanceof Date && b instanceof Date)
                return a.getTime() === b.getTime();

            if (!a || !b || (typeof a !== "object" && typeof b !== "object"))
                return a === b;

            if (a.prototype !== b.prototype) return false;

            // eslint-disable-next-line @typescript-eslint/typedef
            const keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;

            return keys.every((k) => ks.equals(a[k], b[k]));
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.equals");
            return false;
        }
    };
    public static DoCallBack = (
        Callback: any | null,
        Params?: any,
        MakeCBNull?: boolean
    ): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog === false) {
            return;
        }
        try {
            if (typeof Callback === "function") {
                if (ks.kNotNullOrUndefined(Params)) {
                    Callback(Params);
                } else {
                    Callback();
                }
            }
            if (MakeCBNull !== false) {
                Callback = null;
            }
            Params = null;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.DoCallBack");
        }
    };
    public static ClearUnsafeFileChars = (OrgFileName:string ): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            OrgFileName = OrgFileName.replace("/", " ");
            OrgFileName = OrgFileName.replace(":", " ");
            OrgFileName = OrgFileName.replace(";", " ");
            OrgFileName = OrgFileName.replace("'", " ");
            OrgFileName = OrgFileName.replace("?", "");
            OrgFileName = OrgFileName.replace("%", "");
            OrgFileName = OrgFileName.replace("$", "");
            OrgFileName = OrgFileName.replace("(", "");
            OrgFileName = OrgFileName.replace(")", "");                                                          
            return OrgFileName;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.ClearUnsafeFileChars");
            return "";
        }
    };
    public static NewTime = (
        Year?: number,
        Month?: number,
        Day?: number,
        Hour?: number,
        Minute?: number,
        Second?: number,
        MilliSecond?: number
    ): kTime => {
        if (ks.kErrorMode === true) {
            return new kTime();
        }
        try {
            const TimeObj: kTime = new kTime();
            const Now: Date = new Date();
            if (Year === undefined) {
                TimeObj.Year = Now.getFullYear();
                TimeObj.Month = Now.getMonth() + 1;
                TimeObj.Day = Now.getDate();
                TimeObj.Hour = Now.getHours();
                TimeObj.Minute = Now.getMinutes();
                TimeObj.Second = Now.getSeconds();
                TimeObj.MilliSecond = Now.getMilliseconds();
            } else {
                TimeObj.Day = ks.n0(Day);
                TimeObj.Year = Year;
                TimeObj.Month = ks.n0(Month);
                TimeObj.Hour = ks.n0(Hour);
                TimeObj.Minute = ks.n0(Minute);
                TimeObj.Second = ks.n0(Second);
                TimeObj.MilliSecond = ks.n0(MilliSecond);
            }
            return TimeObj;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.NewTime");
            return new kTime();
        }
    };
    public static NewTimeFromISO = (ISODate: string): kTime => {
        if (ks.kErrorMode === true) {
            return new kTime();
        }
        try {
            const TimeObj: kTime = new kTime();
            TimeObj.fromISO(ISODate);
            return TimeObj.clone();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.NewTimeFromISO");
            return new kTime();
        }
    };
    public static NewTimeFromJSON = (JSONObj: any): kTime => {
        if (ks.kErrorMode === true) {
            return new kTime();
        }
        try {
            if (ks.kNotNullOrUndefined(JSONObj)) {
                const TimeObj: kTime = new kTime();
                TimeObj.FromJSON(JSONObj);
                return TimeObj;
            } else {
                return new kTime();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.NewTimeFromJSON");
            return new kTime();
        }
    };
    public static NewTimeFromSP = (
        SPTime: string,
        AllDay?: boolean
    ): kTime | null => {
        if (ks.kErrorMode === true) {
            return null;
        }
        try {
            if (ks.kNotNullOrUndefined(SPTime)) {
                const TimeObj: kTime = new kTime();
                TimeObj.FromSPDate(SPTime, AllDay);
                return TimeObj;
            } else {
                return null;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.NewTimeFromSP");
            return null;
        }
    };
    public static nz = (value: any): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if (ks.kNotNullOrUndefined(value)) {
                switch (typeof value) {
                    case "number":
                        return (value as number).toString();
                        //break;
                    default:
                        // if(isNaN(value)){
                        //     return "";
                        // }else{
                            return value;
                        // }
                        //break;
                }
            } else {
                return "";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.nz");
            return "";
        }
    };
    public static BooleanToString = (value: boolean): string => {
        if (ks.kErrorMode === true) {
            return "false";
        }
        try {
            if(value){
                return "true";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.BooleanToString");

        }
        return "false";
    };
    public static nb = (value: any): boolean => {
        if (ks.kErrorMode === true) {
            return false;
        }
        try {
            if (ks.kNotNullOrUndefined(value)) {
                return Boolean(value);
            } else {
                if (value === true) {
                    return true;
                } else {
                    if (value === "true") {
                        return true;
                    }
                }
            }
            return false;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.nb");
            return false;
        }
    };
    public static nt = (value: any): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if (ks.kNotEmptyString(value)) {
                return value;
            } else {
                return "";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.nt");
            return "";
        }
    };
    public static n0 = (value: any): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            let LocalValue:string = value;
            if(typeof(value ==="string")){
                LocalValue = ks.replaceAll(" ","",value);
            }else{
                LocalValue = value;
            }
            const RetVal: number = parseFloat(LocalValue);
            if (ks.kNotNullOrUndefined(value)) {
                if (isNaN(RetVal)) {
                    return 0;
                } else {
                    return RetVal;
                }
            } else {
                return 0;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.nz");
            return 0;
        }
    };

    public static kStartTimer = (TimerName: string): void => {
        if (ks.kDebugMode === false) {
            return;
        }
        if (ks.kTimers === null) {
            ks.kTimers = new kTimers();
        }
        ks.kTimers.AddTimer(TimerName);
    };
    public static kEndTimer = (
        TimerName: string,
        AllEnding?: boolean
    ): number => {
        if (ks.kDebugMode === false) {
            return 0;
        }
        if (ks.kTimers === null) {
            ks.kTimers = new kTimers();
        }
        if (AllEnding) {
            ks.kTimers.EndAllTimers();
        } else {
            return ks.kTimers.EndTimer(TimerName);
        }
        return 0;
    };
    public static kEndAllTimers = (): void => {
        if (ks.kDebugMode === false) {
            return;
        }
        if (ks.kTimers === null) {
            ks.kTimers = new kTimers();
        }
        ks.kTimers.EndAllTimers();
    };
    public static validateEmail = (email: string): boolean => {
        const reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (reg.test(email)) {
            const Parts: string[] = email.toLowerCase().split(".");
            if (Parts && Parts.length > 1) {
                const TLD: string | undefined = Parts.pop();
                if (TLD !== undefined) {
                    const ValidDomains: string[] = ['aaa', 'aarp', 'abb', 'abbott', 'abbvie', 'abc', 'able', 'abogado', 'abudhabi', 'ac', 'academy', 'accenture', 'accountant', 'accountants', 'aco', 'actor', 'ad', 'ads', 'adult', 'ae', 'aeg', 'aero', 'aetna', 'af', 'afl', 'africa', 'ag', 'agakhan', 'agency', 'ai', 'aig', 'airbus', 'airforce', 'airtel', 'akdn', 'al', 'alibaba', 'alipay', 'allfinanz', 'allstate', 'ally', 'alsace', 'alstom', 'am', 'amazon', 'americanexpress', 'americanfamily', 'amex', 'amfam', 'amica', 'amsterdam', 'analytics', 'android', 'anquan', 'anz', 'ao', 'aol', 'apartments', 'app', 'apple', 'aq', 'aquarelle', 'ar', 'arab', 'aramco', 'archi', 'army', 'arpa', 'art', 'arte', 'as', 'asda', 'asia', 'associates', 'at', 'athleta', 'attorney', 'au', 'auction', 'audi', 'audible', 'audio', 'auspost', 'author', 'auto', 'autos', 'aw', 'aws', 'ax', 'axa', 'az', 'azure', 'ba', 'baby', 'baidu', 'banamex', 'band', 'bank', 'bar', 'barcelona', 'barclaycard', 'barclays', 'barefoot', 'bargains', 'baseball', 'basketball', 'bauhaus', 'bayern', 'bb', 'bbc', 'bbt', 'bbva', 'bcg', 'bcn', 'bd', 'be', 'beats', 'beauty', 'beer', 'bentley', 'berlin', 'best', 'bestbuy', 'bet', 'bf', 'bg', 'bh', 'bharti', 'bi', 'bible', 'bid', 'bike', 'bing', 'bingo', 'bio', 'biz', 'bj', 'black', 'blackfriday', 'blockbuster', 'blog', 'bloomberg', 'blue', 'bm', 'bms', 'bmw', 'bn', 'bnpparibas', 'bo', 'boats', 'boehringer', 'bofa', 'bom', 'bond', 'boo', 'book', 'booking', 'bosch', 'bostik', 'boston', 'bot', 'boutique', 'box', 'br', 'bradesco', 'bridgestone', 'broadway', 'broker', 'brother', 'brussels', 'bs', 'bt', 'build', 'builders', 'business', 'buy', 'buzz', 'bv', 'bw', 'by', 'bz', 'bzh', 'ca', 'cab', 'cafe', 'cal', 'call', 'calvinklein', 'cam', 'camera', 'camp', 'canon', 'capetown', 'capital', 'capitalone', 'car', 'caravan', 'cards', 'care', 'career', 'careers', 'cars', 'casa', 'case', 'cash', 'casino', 'cat', 'catering', 'catholic', 'cba', 'cbn', 'cbre', 'cc', 'cd', 'center', 'ceo', 'cern', 'cf', 'cfa', 'cfd', 'cg', 'ch', 'chanel', 'channel', 'charity', 'chase', 'chat', 'cheap', 'chintai', 'christmas', 'chrome', 'church', 'ci', 'cipriani', 'circle', 'cisco', 'citadel', 'citi', 'citic', 'city', 'ck', 'cl', 'claims', 'cleaning', 'click', 'clinic', 'clinique', 'clothing', 'cloud', 'club', 'clubmed', 'cm', 'cn', 'co', 'coach', 'codes', 'coffee', 'college', 'cologne', 'com', 'commbank', 'community', 'company', 'compare', 'computer', 'comsec', 'condos', 'construction', 'consulting', 'contact', 'contractors', 'cooking', 'cool', 'coop', 'corsica', 'country', 'coupon', 'coupons', 'courses', 'cpa', 'cr', 'credit', 'creditcard', 'creditunion', 'cricket', 'crown', 'crs', 'cruise', 'cruises', 'cu', 'cuisinella', 'cv', 'cw', 'cx', 'cy', 'cymru', 'cyou', 'cz', 'dad', 'dance', 'data', 'date', 'dating', 'datsun', 'day', 'dclk', 'dds', 'de', 'deal', 'dealer', 'deals', 'degree', 'delivery', 'dell', 'deloitte', 'delta', 'democrat', 'dental', 'dentist', 'desi', 'design', 'dev', 'dhl', 'diamonds', 'diet', 'digital', 'direct', 'directory', 'discount', 'discover', 'dish', 'diy', 'dj', 'dk', 'dm', 'dnp', 'do', 'docs', 'doctor', 'dog', 'domains', 'dot', 'download', 'drive', 'dtv', 'dubai', 'dunlop', 'dupont', 'durban', 'dvag', 'dvr', 'dz', 'earth', 'eat', 'ec', 'eco', 'edeka', 'edu', 'education', 'ee', 'eg', 'email', 'emerck', 'energy', 'engineer', 'engineering', 'enterprises', 'epson', 'equipment', 'er', 'ericsson', 'erni', 'es', 'esq', 'estate', 'et', 'eu', 'eurovision', 'eus', 'events', 'exchange', 'expert', 'exposed', 'express', 'extraspace', 'fage', 'fail', 'fairwinds', 'faith', 'family', 'fan', 'fans', 'farm', 'farmers', 'fashion', 'fast', 'fedex', 'feedback', 'ferrari', 'ferrero', 'fi', 'fidelity', 'fido', 'film', 'final', 'finance', 'financial', 'fire', 'firestone', 'firmdale', 'fish', 'fishing', 'fit', 'fitness', 'fj', 'fk', 'flickr', 'flights', 'flir', 'florist', 'flowers', 'fly', 'fm', 'fo', 'foo', 'food', 'football', 'ford', 'forex', 'forsale', 'forum', 'foundation', 'fox', 'fr', 'free', 'fresenius', 'frl', 'frogans', 'frontier', 'ftr', 'fujitsu', 'fun', 'fund', 'furniture', 'futbol', 'fyi', 'ga', 'gal', 'gallery', 'gallo', 'gallup', 'game', 'games', 'gap', 'garden', 'gay', 'gb', 'gbiz', 'gd', 'gdn', 'ge', 'gea', 'gent', 'genting', 'george', 'gf', 'gg', 'ggee', 'gh', 'gi', 'gift', 'gifts', 'gives', 'giving', 'gl', 'glass', 'gle', 'global', 'globo', 'gm', 'gmail', 'gmbh', 'gmo', 'gmx', 'gn', 'godaddy', 'gold', 'goldpoint', 'golf', 'goo', 'goodyear', 'goog', 'google', 'gop', 'got', 'gov', 'gp', 'gq', 'gr', 'grainger', 'graphics', 'gratis', 'green', 'gripe', 'grocery', 'group', 'gs', 'gt', 'gu', 'gucci', 'guge', 'guide', 'guitars', 'guru', 'gw', 'gy', 'hair', 'hamburg', 'hangout', 'haus', 'hbo', 'hdfc', 'hdfcbank', 'health', 'healthcare', 'help', 'helsinki', 'here', 'hermes', 'hiphop', 'hisamitsu', 'hitachi', 'hiv', 'hk', 'hkt', 'hm', 'hn', 'hockey', 'holdings', 'holiday', 'homedepot', 'homegoods', 'homes', 'homesense', 'honda', 'horse', 'hospital', 'host', 'hosting', 'hot', 'hotels', 'hotmail', 'house', 'how', 'hr', 'hsbc', 'ht', 'hu', 'hughes', 'hyatt', 'hyundai', 'ibm', 'icbc', 'ice', 'icu', 'id', 'ie', 'ieee', 'ifm', 'ikano', 'il', 'im', 'imamat', 'imdb', 'immo', 'immobilien', 'in', 'inc', 'industries', 'infiniti', 'info', 'ing', 'ink', 'institute', 'insurance', 'insure', 'int', 'international', 'intuit', 'investments', 'io', 'ipiranga', 'iq', 'ir', 'irish', 'is', 'ismaili', 'ist', 'istanbul', 'it', 'itau', 'itv', 'jaguar', 'java', 'jcb', 'je', 'jeep', 'jetzt', 'jewelry', 'jio', 'jll', 'jm', 'jmp', 'jnj', 'jo', 'jobs', 'joburg', 'jot', 'joy', 'jp', 'jpmorgan', 'jprs', 'juegos', 'juniper', 'kaufen', 'kddi', 'ke', 'kerryhotels', 'kerrylogistics', 'kerryproperties', 'kfh', 'kg', 'kh', 'ki', 'kia', 'kids', 'kim', 'kindle', 'kitchen', 'kiwi', 'km', 'kn', 'koeln', 'komatsu', 'kosher', 'kp', 'kpmg', 'kpn', 'kr', 'krd', 'kred', 'kuokgroup', 'kw', 'ky', 'kyoto', 'kz', 'la', 'lacaixa', 'lamborghini', 'lamer', 'lancaster', 'land', 'landrover', 'lanxess', 'lasalle', 'lat', 'latino', 'latrobe', 'law', 'lawyer', 'lb', 'lc', 'lds', 'lease', 'leclerc', 'lefrak', 'legal', 'lego', 'lexus', 'lgbt', 'li', 'lidl', 'life', 'lifeinsurance', 'lifestyle', 'lighting', 'like', 'lilly', 'limited', 'limo', 'lincoln', 'link', 'lipsy', 'live', 'living', 'lk', 'llc', 'llp', 'loan', 'loans', 'locker', 'locus', 'lol', 'london', 'lotte', 'lotto', 'love', 'lpl', 'lplfinancial', 'lr', 'ls', 'lt', 'ltd', 'ltda', 'lu', 'lundbeck', 'luxe', 'luxury', 'lv', 'ly', 'ma', 'madrid', 'maif', 'maison', 'makeup', 'man', 'management', 'mango', 'map', 'market', 'marketing', 'markets', 'marriott', 'marshalls', 'mattel', 'mba', 'mc', 'mckinsey', 'md', 'me', 'med', 'media', 'meet', 'melbourne', 'meme', 'memorial', 'men', 'menu', 'merckmsd', 'mg', 'mh', 'miami', 'microsoft', 'mil', 'mini', 'mint', 'mit', 'mitsubishi', 'mk', 'ml', 'mlb', 'mls', 'mm', 'mma', 'mn', 'mo', 'mobi', 'mobile', 'moda', 'moe', 'moi', 'mom', 'monash', 'money', 'monster', 'mormon', 'mortgage', 'moscow', 'moto', 'motorcycles', 'mov', 'movie', 'mp', 'mq', 'mr', 'ms', 'msd', 'mt', 'mtn', 'mtr', 'mu', 'museum', 'music', 'mv', 'mw', 'mx', 'my', 'mz', 'na', 'nab', 'nagoya', 'name', 'navy', 'nba', 'nc', 'ne', 'nec', 'net', 'netbank', 'netflix', 'network', 'neustar', 'new', 'news', 'next', 'nextdirect', 'nexus', 'nf', 'nfl', 'ng', 'ngo', 'nhk', 'ni', 'nico', 'nike', 'nikon', 'ninja', 'nissan', 'nissay', 'nl', 'no', 'nokia', 'norton', 'now', 'nowruz', 'nowtv', 'np', 'nr', 'nra', 'nrw', 'ntt', 'nu', 'nyc', 'nz', 'obi', 'observer', 'office', 'okinawa', 'olayan', 'olayangroup', 'ollo', 'om', 'omega', 'one', 'ong', 'onl', 'online', 'ooo', 'open', 'oracle', 'orange', 'org', 'organic', 'origins', 'osaka', 'otsuka', 'ott', 'ovh', 'pa', 'page', 'panasonic', 'paris', 'pars', 'partners', 'parts', 'party', 'pay', 'pccw', 'pe', 'pet', 'pf', 'pfizer', 'pg', 'ph', 'pharmacy', 'phd', 'philips', 'phone', 'photo', 'photography', 'photos', 'physio', 'pics', 'pictet', 'pictures', 'pid', 'pin', 'ping', 'pink', 'pioneer', 'pizza', 'pk', 'pl', 'place', 'play', 'playstation', 'plumbing', 'plus', 'pm', 'pn', 'pnc', 'pohl', 'poker', 'politie', 'porn', 'post', 'pr', 'pramerica', 'praxi', 'press', 'prime', 'pro', 'prod', 'productions', 'prof', 'progressive', 'promo', 'properties', 'property', 'protection', 'pru', 'prudential', 'ps', 'pt', 'pub', 'pw', 'pwc', 'py', 'qa', 'qpon', 'quebec', 'quest', 'racing', 'radio', 're', 'read', 'realestate', 'realtor', 'realty', 'recipes', 'red', 'redstone', 'redumbrella', 'rehab', 'reise', 'reisen', 'reit', 'reliance', 'ren', 'rent', 'rentals', 'repair', 'report', 'republican', 'rest', 'restaurant', 'review', 'reviews', 'rexroth', 'rich', 'richardli', 'ricoh', 'ril', 'rio', 'rip', 'ro', 'rocks', 'rodeo', 'rogers', 'room', 'rs', 'rsvp', 'ru', 'rugby', 'ruhr', 'run', 'rw', 'rwe', 'ryukyu', 'sa', 'saarland', 'safe', 'safety', 'sakura', 'sale', 'salon', 'samsclub', 'samsung', 'sandvik', 'sandvikcoromant', 'sanofi', 'sap', 'sarl', 'sas', 'save', 'saxo', 'sb', 'sbi', 'sbs', 'sc', 'scb', 'schaeffler', 'schmidt', 'scholarships', 'school', 'schule', 'schwarz', 'science', 'scot', 'sd', 'se', 'search', 'seat', 'secure', 'security', 'seek', 'select', 'sener', 'services', 'seven', 'sew', 'sex', 'sexy', 'sfr', 'sg', 'sh', 'shangrila', 'sharp', 'shell', 'shia', 'shiksha', 'shoes', 'shop', 'shopping', 'shouji', 'show', 'si', 'silk', 'sina', 'singles', 'site', 'sj', 'sk', 'ski', 'skin', 'sky', 'skype', 'sl', 'sling', 'sm', 'smart', 'smile', 'sn', 'sncf', 'so', 'soccer', 'social', 'softbank', 'software', 'sohu', 'solar', 'solutions', 'song', 'sony', 'soy', 'spa', 'space', 'sport', 'spot', 'sr', 'srl', 'ss', 'st', 'stada', 'staples', 'star', 'statebank', 'statefarm', 'stc', 'stcgroup', 'stockholm', 'storage', 'store', 'stream', 'studio', 'study', 'style', 'su', 'sucks', 'supplies', 'supply', 'support', 'surf', 'surgery', 'suzuki', 'sv', 'swatch', 'swiss', 'sx', 'sy', 'sydney', 'systems', 'sz', 'tab', 'taipei', 'talk', 'taobao', 'target', 'tatamotors', 'tatar', 'tattoo', 'tax', 'taxi', 'tc', 'tci', 'td', 'tdk', 'team', 'tech', 'technology', 'tel', 'temasek', 'tennis', 'teva', 'tf', 'tg', 'th', 'thd', 'theater', 'theatre', 'tiaa', 'tickets', 'tienda', 'tips', 'tires', 'tirol', 'tj', 'tjmaxx', 'tjx', 'tk', 'tkmaxx', 'tl', 'tm', 'tmall', 'tn', 'to', 'today', 'tokyo', 'tools', 'top', 'toray', 'toshiba', 'total', 'tours', 'town', 'toyota', 'toys', 'tr', 'trade', 'trading', 'training', 'travel', 'travelers', 'travelersinsurance', 'trust', 'trv', 'tt', 'tube', 'tui', 'tunes', 'tushu', 'tv', 'tvs', 'tw', 'tz', 'ua', 'ubank', 'ubs', 'ug', 'uk', 'unicom', 'university', 'uno', 'uol', 'ups', 'us', 'uy', 'uz', 'va', 'vacations', 'vana', 'vanguard', 'vc', 've', 'vegas', 'ventures', 'verisign', 'versicherung', 'vet', 'vg', 'vi', 'viajes', 'video', 'vig', 'viking', 'villas', 'vin', 'vip', 'virgin', 'visa', 'vision', 'viva', 'vivo', 'vlaanderen', 'vn', 'vodka', 'volvo', 'vote', 'voting', 'voto', 'voyage', 'vu', 'wales', 'walmart', 'walter', 'wang', 'wanggou', 'watch', 'watches', 'weather', 'weatherchannel', 'webcam', 'weber', 'website', 'wed', 'wedding', 'weibo', 'weir', 'wf', 'whoswho', 'wien', 'wiki', 'williamhill', 'win', 'windows', 'wine', 'winners', 'wme', 'wolterskluwer', 'woodside', 'work', 'works', 'world', 'wow', 'ws', 'wtc', 'wtf', 'xbox', 'xerox', 'xihuan', 'xin', 'xn--11b4c3d', 'xn--1ck2e1b', 'xn--1qqw23a', 'xn--2scrj9c', 'xn--30rr7y', 'xn--3bst00m', 'xn--3ds443g', 'xn--3e0b707e', 'xn--3hcrj9c', 'xn--3pxu8k', 'xn--42c2d9a', 'xn--45br5cyl', 'xn--45brj9c', 'xn--45q11c', 'xn--4dbrk0ce', 'xn--4gbrim', 'xn--54b7fta0cc', 'xn--55qw42g', 'xn--55qx5d', 'xn--5su34j936bgsg', 'xn--5tzm5g', 'xn--6frz82g', 'xn--6qq986b3xl', 'xn--80adxhks', 'xn--80ao21a', 'xn--80aqecdr1a', 'xn--80asehdb', 'xn--80aswg', 'xn--8y0a063a', 'xn--90a3ac', 'xn--90ae', 'xn--90ais', 'xn--9dbq2a', 'xn--9et52u', 'xn--9krt00a', 'xn--b4w605ferd', 'xn--bck1b9a5dre4c', 'xn--c1avg', 'xn--c2br7g', 'xn--cck2b3b', 'xn--cckwcxetd', 'xn--cg4bki', 'xn--clchc0ea0b2g2a9gcd', 'xn--czr694b', 'xn--czrs0t', 'xn--czru2d', 'xn--d1acj3b', 'xn--d1alf', 'xn--e1a4c', 'xn--eckvdtc9d', 'xn--efvy88h', 'xn--fct429k', 'xn--fhbei', 'xn--fiq228c5hs', 'xn--fiq64b', 'xn--fiqs8s', 'xn--fiqz9s', 'xn--fjq720a', 'xn--flw351e', 'xn--fpcrj9c3d', 'xn--fzc2c9e2c', 'xn--fzys8d69uvgm', 'xn--g2xx48c', 'xn--gckr3f0f', 'xn--gecrj9c', 'xn--gk3at1e', 'xn--h2breg3eve', 'xn--h2brj9c', 'xn--h2brj9c8c', 'xn--hxt814e', 'xn--i1b6b1a6a2e', 'xn--imr513n', 'xn--io0a7i', 'xn--j1aef', 'xn--j1amh', 'xn--j6w193g', 'xn--jlq480n2rg', 'xn--jvr189m', 'xn--kcrx77d1x4a', 'xn--kprw13d', 'xn--kpry57d', 'xn--kput3i', 'xn--l1acc', 'xn--lgbbat1ad8j', 'xn--mgb9awbf', 'xn--mgba3a3ejt', 'xn--mgba3a4f16a', 'xn--mgba7c0bbn0a', 'xn--mgbaam7a8h', 'xn--mgbab2bd', 'xn--mgbah1a3hjkrd', 'xn--mgbai9azgqp6j', 'xn--mgbayh7gpa', 'xn--mgbbh1a', 'xn--mgbbh1a71e', 'xn--mgbc0a9azcg', 'xn--mgbca7dzdo', 'xn--mgbcpq6gpa1a', 'xn--mgberp4a5d4ar', 'xn--mgbgu82a', 'xn--mgbi4ecexp', 'xn--mgbpl2fh', 'xn--mgbt3dhd', 'xn--mgbtx2b', 'xn--mgbx4cd0ab', 'xn--mix891f', 'xn--mk1bu44c', 'xn--mxtq1m', 'xn--ngbc5azd', 'xn--ngbe9e0a', 'xn--ngbrx', 'xn--node', 'xn--nqv7f', 'xn--nqv7fs00ema', 'xn--nyqy26a', 'xn--o3cw4h', 'xn--ogbpf8fl', 'xn--otu796d', 'xn--p1acf', 'xn--p1ai', 'xn--pgbs0dh', 'xn--pssy2u', 'xn--q7ce6a', 'xn--q9jyb4c', 'xn--qcka1pmc', 'xn--qxa6a', 'xn--qxam', 'xn--rhqv96g', 'xn--rovu88b', 'xn--rvc1e0am3e', 'xn--s9brj9c', 'xn--ses554g', 'xn--t60b56a', 'xn--tckwe', 'xn--tiq49xqyj', 'xn--unup4y', 'xn--vermgensberater-ctb', 'xn--vermgensberatung-pwb', 'xn--vhquv', 'xn--vuq861b', 'xn--w4r85el8fhu5dnra', 'xn--w4rs40l', 'xn--wgbh1c', 'xn--wgbl6a', 'xn--xhq521b', 'xn--xkc2al3hye2a', 'xn--xkc2dl3a5ee0h', 'xn--y9a3aq', 'xn--yfro4i67o', 'xn--ygbi2ammx', 'xn--zfr164b', 'xxx', 'xyz', 'yachts', 'yahoo', 'yamaxun', 'yandex', 'ye', 'yodobashi', 'yoga', 'yokohama', 'you', 'youtube', 'yt', 'yun', 'za', 'zappos', 'zara', 'zero', 'zip', 'zm', 'zone', 'zuerich', 'zw'];
                    if (ValidDomains.indexOf(TLD) > -1) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    public static ThrowError = (): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            const json = "{ bad json }";
            const user: object = JSON.parse(json);
            console.log(json);
            console.log(user);
            return 0;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromshared.ThrowError");
            return 0;
        }
    };
    public static kGlobalErrorHandler = (
        e: any,
        strFunction: string,
        AdditionalMessage?: string
    ): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        if (ks.ErrorTriggered === false) {
            ks.ErrorTriggered = true;
        } else {
            return;
        }
        // debugger;
        console.log(e);
        ks.DoActions("OnGlobalError");
        let strMessage = "ERROR:\n",
            LineNumber = 0,
            ErrorFile = "",
            ErrorMessage = "",
            StackParts: string[] = [],
            Stacktrack = "";
        strMessage +=
            "Release: " +
            ks.kApplication.name +
            "v: " +
            ks.kApplication.version +
            "\n\n";
        strMessage += "**************\n\r";
        strMessage += "Function: " + strFunction + "\n\r";

        if (e !== null && e !== undefined && typeof e === "string") {
            ErrorMessage = e;
            strMessage += "ErrorDescription: " + e + "\n\r";
        }

        if (e !== null && e !== undefined && typeof e !== "string") {
            if (e.lineNo !== undefined) {
                strMessage += "Line: " + e.lineNo + "\n\r";
                LineNumber = e.lineNo;
            }
            if (e.lineNumber !== undefined) {
                strMessage += "Line: " + e.lineNumber + "\n\r";
                LineNumber = e.lineNumber;
            }
            if (LineNumber === 0) {
                try {
                    LineNumber = parseInt(e.stack.split("\n")[1].split(":")[2]);
                } catch {
                    LineNumber = 0;
                }
            }

            if (e.name !== undefined) {
                strMessage += "Name: " + e.name + "\n\r";
            }
            if (e.message !== undefined) {
                strMessage += "Message: " + e.message + "\n\r";
                ErrorMessage = e.message;
            }
            if (ks.kNotNullOrUndefined(e.responseJSON)) {
                ErrorMessage = e.responseJSON.error.message.value + "\n";
            }

            if (e.stack !== undefined) {
                if (LineNumber === 0) {
                    //Try to split the line number out of the stack
                    try {
                        StackParts = e.stack
                            .toString()
                            .split("(")[1]
                            .split(")")[0]
                            .split(".ts:");
                        LineNumber = parseInt(StackParts[1]);
                        if (isNaN(LineNumber)) {
                            LineNumber = 0;
                        }
                        if (ErrorFile === "") ErrorFile = StackParts[0];
                    } catch {
                        LineNumber = 0;
                    }
                }
                strMessage += e.stack.toString();
            }
        }

        if (ks.kNotEmptyString(AdditionalMessage)) {
            strMessage += "Additional info:" + AdditionalMessage + "\n\r";
        } else {
            AdditionalMessage = "";
        }

        if (e !== null && e !== undefined) {
            if (e.stack !== undefined) {
                Stacktrack = e.stack.toString()
                Stacktrack = ks.replaceAll("\n", "<br>", Stacktrack)
                strMessage += "Stack: \n\r" + Stacktrack + "\n\r";
            }
        }
        strMessage += "URL: " + document.location.href + "\n";
        strMessage += "**************\n";

        const emailVal: string = ks.UserObject && ks.UserObject.Email ? ks.UserObject.Email : "";
        let html: string = '<div style="font-family:\'Segoe UI\',sans-serif;user-select:text;">'
            + '<div style="display:flex;align-items:flex-start;gap:12px;margin-bottom:14px;padding-bottom:12px;border-bottom:1px solid #f0f0f0;">'
            +   '<div style="font-size:28px;line-height:1;flex-shrink:0;">&#9888;</div>'
            +   '<div style="flex:1;min-width:0;">'
            +     '<div style="font-size:15px;font-weight:700;color:#c0392b;margin-bottom:4px;word-break:break-word;">' + ErrorMessage.replace("\n\r","<br>") + '</div>'
            +     '<div style="font-size:11px;color:#888;font-family:monospace;word-break:break-all;">' + strFunction + '</div>'
            +   '</div>'
            + '</div>'
            + '<div style="font-size:12px;color:#555;margin-bottom:12px;display:grid;grid-template-columns:auto 1fr;gap:4px 12px;">';
        if (ErrorFile) {
            html += '<span style="font-weight:600;white-space:nowrap;">File:</span>'
                 +  '<span style="font-family:monospace;word-break:break-all;">' + ErrorFile + '</span>';
        }
        if (LineNumber > 0) {
            html += '<span style="font-weight:600;">Line:</span><span>' + LineNumber + '</span>';
        }
        if (ks.kNotEmptyString(AdditionalMessage)) {
            html += '<span style="font-weight:600;">Note:</span>'
                 +  '<span style="word-break:break-word;">' + ks.replaceAll("\n","<br>", ks.nz(AdditionalMessage)) + '</span>';
        }
        const CopyableErrorText: string = ks.nz(ErrorMessage) + "\n" + strFunction + (ErrorFile ? "\nFile: " + ErrorFile : "") + (LineNumber > 0 ? "\nLine: " + LineNumber : "") + "\n" + ks.nz(Stacktrack);
        html += '</div>'
            + '<div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">'
            +   '<details style="flex:1;">'
            +     '<summary style="cursor:pointer;font-size:12px;color:#666;user-select:none;">&#9656; Details</summary>'
            +     '<div style="font-family:monospace;font-size:10px;overflow:auto;max-height:160px;background:#1e1e1e;color:#d4d4d4;padding:10px;border-radius:4px;margin:6px 0 0;white-space:pre-wrap;word-break:break-all;user-select:text;-webkit-user-select:text;">' + Stacktrack + '</div>'
            +   '</details>'
            +   '<button id="k-error-copy-btn" style="font-size:11px;padding:4px 10px;border:1px solid #ccc;border-radius:4px;background:#f5f5f5;cursor:pointer;white-space:nowrap;">Copy error</button>'
            + '</div>'
            + '<div style="margin-bottom:12px;">'
            +   '<input type="email" id="k-error-email" placeholder="your@email.com (optional)" value="' + emailVal + '" style="width:100%;box-sizing:border-box;padding:6px 8px;border:1px solid #ddd;border-radius:4px;font-size:12px;" />'
            + '</div>'
            + '<div style="font-size:13px;font-weight:600;color:#444;">' + (ks.ReportToBoostly ? LNG.SENDTOBOOSTLY : LNG.SENDTOKALMSTROM) + '</div>'
            + '</div>';
        let Title: string =
            ks.kApplication.name + " v: " + ks.kApplication.version;
        if(ks.kApplication.apptype === 2){
            Title += " .wsp";
        }else{
            Title += " SPFX";
        }

        ks.ErrorDetails.FunctionName = strFunction;
        ks.ErrorDetails.Message = strMessage;
        ks.ErrorDetails.ErrorFile = ErrorFile;
        if (ks.kNotNullOrUndefined(LineNumber)) {
            ks.ErrorDetails.LineNumber = LineNumber;
        }
        ks.kErrorMode = false;
        ks.kShowingErrorDialog = true;
        ks.ConfirmYesNo(html,ks._ErrorDialogCallback,LNG.YES,LNG.NO,null,Title,500,500);
        ks._BindErrorCopyButton(CopyableErrorText);
        ks.kErrorMode = true;
    };

    private static _BindErrorCopyButton = (ErrorText: string): void => {
        window.setTimeout(() => {
            const CopyBtn: HTMLButtonElement | null = document.getElementById("k-error-copy-btn") as HTMLButtonElement | null;
            if (CopyBtn) {
                CopyBtn.addEventListener("click", () => {
                    ks.copyToClipboard(ErrorText);
                    CopyBtn.textContent = "Copied!";
                    window.setTimeout(() => { CopyBtn.textContent = "Copy error"; }, 1500);
                });
            }
        }, 50);
    };

    private static _ErrorDialogCallback = (): void => {
        try {
            ks.kErrorMode = false;
            // Close the visible Yes/No dialog before sending report
            if (ks._YesNoDialog) {
                ks._YesNoDialog.Close();
            }
            ks.kShowingErrorDialog = false;
            ks._ReportData(
                ks.ErrorDetails.FunctionName,
                ks.ErrorDetails.Message,
                ks.ErrorDetails.LineNumber,
                ks.ErrorDetails.ErrorFile
            );
            ks.kErrorMode = true;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromshared._ErrorDialogCallback");
        }
    };
    public static _ReportData = (
        strFunction: string,
        strMessage: string,
        LineNumber: number,
        ErrorFile: string
    ): void => {
        try {
            let DataToReport: any;
            // Read email from the inline field in the error dialog (still in DOM after hide)
            const emailInput: HTMLInputElement | null = document.getElementById("k-error-email") as HTMLInputElement | null;
            let ContactEmail: string = emailInput ? emailInput.value.trim() : (ks.UserObject && ks.UserObject.Email ? ks.UserObject.Email : "");
            let productName: string = ks.kApplication.name;
            if (!ks.kNotEmptyString(productName)) {
                productName = window.location.href;
                const hashIndex: number = productName.indexOf("#");
                const QueIndex: number = productName.indexOf("?");
                if (hashIndex > -1 || QueIndex > -1) {
                    if (hashIndex > QueIndex) {
                        productName = productName.substring(0, hashIndex);
                    } else {
                        productName = productName.substring(0, QueIndex);
                    }
                }
            }
            if (ContactEmail !== "") {
                DataToReport = {
                    ProductName:
                        ks.kApplication.name + " " + ks.kApplication.version,
                    FunctionName: strFunction,
                    ErrorFileName: ErrorFile,
                    ErrorNumber: ks.nz(LineNumber),
                    ErrorDescription: strMessage,
                    Comments: "",
                    ClientName: ks.UserObject.Name,
                    ClientEmail: ContactEmail,
                    OSVersion: window.navigator.userAgent,
                };
                ks.kReportError(DataToReport);
            }
        } catch (e) {
            //Ignore error
        }
    };
    public static kReportError = (DataToSend: any): void => {
        const unableTemplate: string = ks.ReportToBoostly ? LNG.UNABLETOSENDBOOSTLY : LNG.UNABLETOSEND;
        const strErrorMessage: string = unableTemplate.replace("\\n", "\n");
        try {
            const ErrorReq:kRequest = new kRequest();
            ErrorReq.ContentType = "application/json; charset=utf-8";
            ErrorReq.Data = JSON.stringify(DataToSend);
            ErrorReq.Call(ks.kServicesURL,"POST",ks.SuccessCallback);
            return;
        } catch (e) {
            window.alert(strErrorMessage);
        }
    };

    public static SuccessCallback = (): void => {
        const thanksTemplate: string = ks.ReportToBoostly ? LNG.THANKSFORSENDINGBOSSTLY : LNG.THANKSFORSENDING;
        const ThanksMsg: string = thanksTemplate.replace(
            /<a href="mailto:[^"]*">/g,
            ""
        ).replace("</a>", "");
        ks.kErrorMode = false;
        kNotification.ShowNew(ThanksMsg);
        ks.kErrorMode = true;
    };

    public static replaceAll = (
        StringToFind: string,
        ReplaceWith: string,
        StringToSearchIn: string
    ): string => {
        if (!ks.kNotEmptyString(StringToSearchIn)) {
            return StringToSearchIn;
        }
        return StringToSearchIn.toString()
            .split(StringToFind)
            .join(ReplaceWith);
    };
    public static kNotNullOrUndefined = (varToCheck: any): boolean => {
        if (varToCheck === null) {
            return false;
        } else {
            if (varToCheck === undefined) {
                return false;
            } else {
                if (varToCheck === "undefined") {
                    return false;
                } else {
                    if (varToCheck === "null") {
                        return false;
                    }
                }
            }
        }
        return true;
    };
    public static kNotEmptyString = (varToCheck: any): boolean => {
        if (ks.kErrorMode === true) {
            return false;
        }
        try {
            if (ks.kNotNullOrUndefined(varToCheck) === true) {
                if (varToCheck !== "") {
                    if (varToCheck.length === 1) {
                        if (typeof varToCheck === "string") {
                            if (varToCheck.charCodeAt(0) === 8203) {
                                return false;
                            }
                        }
                    }
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromshared.kNotEmptyString");
            return false;
        }
    };
    public static kNotEmptyHTML = (StringToCheck: string): boolean => {
        if (ks.kNotEmptyString(StringToCheck) === true) {
            if (ks.kNotEmptyString(StringToCheck.trim())) {
                const PlainText: string = ks
                    .PlainTextFromHTML(StringToCheck)
                    .trim();
                if (ks.kNotEmptyString(PlainText)) {
                    return true; //we have valid content
                }
            }
        }
        return false; //Empty html
    };

    public static PlainTextFromHTML = (HTMLString: string): string => {
        if (ks.kNotEmptyString(HTMLString) === true) {
            const TestDiv: HTMLDivElement = document.createElement("div");
            TestDiv.innerHTML = HTMLString;
            return TestDiv.innerText.trim();
        }
        return ""; //Empty html
    };
    public static kNotInteger = (varToCheck: any): boolean => {
        if (ks.kNotNullOrUndefined(varToCheck) === true) {
            if (varToCheck === "") {
                return true;
            } else if (isNaN(varToCheck) === true) {
                return true;
            }
            return false;
        } else {
            return false;
        }
    };

    public static kIdSlug = (Text: string): string => {
        return Text.toLowerCase().replace(/[^a-z0-9\u00e0-\u024f]/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
    };

    public static StartLongTasks = (
        ProgressTitle: string,
        CallBack: any
    ): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            ks.ShowModalMessage(ProgressTitle, null, false, 200, 300, true);
            ks.AddDelayedAction(
                "Delay",
                CallBack,
                "Starting long task after render",
                50
            );
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromshared.StartLongTasks");
        }
    };

    public static DialogCommonOptions = (
        height: number,
        width: number,
        Title?: string
    ): any => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (!ks.kNotNullOrUndefined(height) || height === 0) {
                height = 200;
            }
            if (!ks.kNotNullOrUndefined(width) || width === 0) {
                width = 300; //good for a short two row message
            }

            const windowOptions: any = {}; // as jqwidgets.WindowOptions;
            windowOptions.theme = "office";
            if (ks.kNotEmptyString(Title)) {
                windowOptions.title = Title;
            } else {
                windowOptions.title = ks.kApplication.name;
            }
            windowOptions.isModal = true;
            windowOptions.height = height;
            windowOptions.width = width;
            if (height > 1200) {
                windowOptions.maxHeight = height;
            }
            if (width > 1200) {
                windowOptions.maxWidth = width;
            }

            windowOptions.resizable = false;
            return windowOptions;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromshared.DialogCommonOptions");
        }
    };
    private static _ModalMessage:kModalDialog |null = null;

    public static ShowModalMessage = (Message: string,CallBack?: any,ShowOK?: boolean,height?: number,width?: number,ShowProgressAnimation?: boolean,Title?: string,GreyTitle?:boolean): void => {
        //KDebug.ks.ShowModalMessage("Testing 2 peter@kalmstrom.com", null, false, 500, 500)
        if (ks.kErrorMode === true) {return;}
        try {
            ks._ModalMessage = new kModalDialog();
            
            if (height) {
                ks._ModalMessage.Height = height;
            }else{
                ks._ModalMessage.Height = 150;
            }
            if (width) {
                ks._ModalMessage.Width = width;
            }else{
                ks._ModalMessage.Width = 300;
            }
            if (undefined === Title) {
                ks._ModalMessage.Title =  ks.nz(ks.kApplication.name);
            }else{
                ks._ModalMessage.Title = Title;
            }
            if (GreyTitle!== false) {
                ks._ModalMessage.SetGreyTitle();
            }

            //insert hyperlinks if there are email addresses in the text
            Message = Message.replace(/([\w-]+@([\w-]+\.)+[\w-]+)/,'<a href="mailto:$1">$1</a>');
            if (ShowProgressAnimation) {
                Message += '<br/><div class="ProgressAnimation"></div><br/>';
            }
            if (ShowOK === true) {
                ks._ModalMessage.AddOKButton();
            } else {
                ks._ModalMessage.showOKButton = false;
            }
            ks._ModalMessage.SetContent(Message);
            ks._ModalMessage.Show();
        } catch (e) {
            //debugger;
            alert(Message);
            // ks.kGlobalErrorHandler(e, "kalmstromshared.ShowModalMessage");
        }
    };


    private static _YesNoDialog:kModalDialog | null = null;

    public static ConfirmYesNo = (ConfirmationText: string,YesCallBack: any,YesCaption?: string,NoCaption?: string,CurrentData?: any,DialogTitle?: string,height?: number,width?: number,NoCallBack?: any): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            ks._YesNoDialog = new kModalDialog();
            if(DialogTitle){
                ks._YesNoDialog.Title = DialogTitle;
            }else{
                ks._YesNoDialog.Title =ks.kApplication.name + " " + ks.kApplication.version; 
            }
            ks._YesNoDialog.SetGreyTitle();
            if (YesCaption) {
                ks._YesNoDialog.OKButtonCaption = YesCaption;
            }else{
                ks._YesNoDialog.OKButtonCaption = LNG.YES;
            }
            ks._YesNoDialog.AddOKButton(YesCallBack)

            if (NoCaption) {
                ks._YesNoDialog.CancelButtonCaption = NoCaption;
            }else{
                ks._YesNoDialog.CancelButtonCaption = LNG.NO;
            }
            ks._YesNoDialog.AddCancelButton(NoCallBack);

            ks._ConfirmCurrentData = CurrentData;
            ks._YesNoDialog.SetContent(ConfirmationText);
            if (height) {
                ks._YesNoDialog.Height = ks.n0(height);
            } else {
                ks._YesNoDialog.Height = 150;
            }
            if (width) {
                ks._YesNoDialog.Width = ks.n0(width);
            } else {
                ks._YesNoDialog.Width = 300;
            }
            ks._YesNoDialog.Show();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.ConfirmYesNo");
        }
    };
    private static _YesClickCB:any = null;
    private static _ConfirmYesNoYesClick = (Event:MouseEvent): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog ===false) {
            return;
        }
        try {
            if (ks._YesNoDialog) {
                ks._YesNoDialog.Close();
            }
            if(ks._YesClickCB){
                ks._YesClickCB();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.ConfirmYesNo");
        }
    };
    public static HideModalMessage = (): void => {
        if (ks.kErrorMode === true && ks.kShowingErrorDialog === false) {
            return;
        }
        try {
            if (ks._ModalMessage) {
                ks._ModalMessage.DialogContainer.style.display = "none";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.HideModalMessage");
        }
    };
    //Finding object functions
    // Useful when declaring an object and adding that to the array.
    // Our objects should always be defined with an ID and a Name property
    //*********************************************
    public static GetObjectByName = (
        ObjectName: string,
        ObjectArray: object[],
        AddIfMissing?: boolean,
        NewObject?: any
    ): any => {
        if (ks.kErrorMode === true) {
            return null;
        }
        let CurrObject: any;
        try {
            if (!ks.kNotEmptyString(ObjectName)) {
                return null;
            }
            for (CurrObject of ObjectArray) {
                if (
                    CurrObject.Name.toLowerCase() ===
                    ObjectName.toString().toLowerCase()
                ) {
                    return CurrObject;
                }
            }
            if (AddIfMissing === true) {
                if (typeof NewObject === "object") {
                    alert(
                        "The function 'GetObjectByName' is modified and you cannot pass new object into it,\nPlease pass whole function as it is, its new object will be created in side method.\nExample code old way= New KTM(), New way=KTM only"
                    );
                    return;
                }
                const NewClone: any = new NewObject();
                NewClone.Name = ObjectName;
                ObjectArray.push(NewClone);
                return NewClone;
            }
            return null;
        } catch (e) {
            ks.kGlobalErrorHandler(
                e,
                "kalmstromShared.GetObjectByName",
                "searching object " + ObjectName + "in collection."
            );
        }
    };
    public static GetObjectByID = (
        ObjectID: number,
        ObjectArray: object[],
        AddIfMissing?: boolean,
        NewObject?: any
    ): any => {
        if (ks.kErrorMode === true) {
            return;
        }
        let CurrObject: any;
        try {
            for (CurrObject of ObjectArray) {
                if (CurrObject.ID === ObjectID) {
                    return CurrObject;
                }
            }
            if (AddIfMissing === true) {
                if (typeof NewObject === "object") {
                    alert(
                        "The function 'GetObjectByID' is modified and you cannot pass new object into it,\nPlease pass whole function as it is, its new object will be created in side method.\nExample code old way= New KTM(), New way=KTM only"
                    );
                    return;
                }
                const NewClone: any = new NewObject();
                NewClone.ID = ObjectID;
                ObjectArray.push(NewClone);
                return NewClone;
            }
            return null;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromshared.GetObjectByID");
        }
    };

    public static GetObjectByTitle = (
        ObjectTitle: string,
        ObjectArray: any
    ): any => {
        if (ks.kErrorMode === true) {
            return false;
        }
        let CurrObject: any;
        try {
            for (CurrObject of ObjectArray) {
                if (CurrObject.Title === ObjectTitle) {
                    return CurrObject;
                }
            }
            return null;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.GetObjectByTitle");
        }
    };
    public static SortObjectsByName = (a: any, b: any): number => {
        if (typeof a.Name !== "undefined") {
            if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
            if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
        }
        return 0;
    };
    public static SortObjectsByNumber = (a: any, b: any): number => {
        if (a.Number < b.Number) return -1;
        if (a.Number > b.Number) return 1;
        return 0;
    };

    public static SortObjectsByTitle = (a: any, b: any): number => {
        if (
            ks.kNotNullOrUndefined(a.Title) &&
            ks.kNotNullOrUndefined(b.Title)
        ) {
            if (typeof a.Title !== "undefined") {
                if (a.Title.toLowerCase() < b.Title.toLowerCase()) return -1;
                if (a.Title.toLowerCase() > b.Title.toLowerCase()) return 1;
            }
            return 0;
        } else {
            return 0;
        }
    };
    public static SortObjectsBylabel = (a: any, b: any): number => {
        if (typeof a.label !== "undefined") {
            if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
            if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
        }
        return 0;
    };
    public static SortDescObjectByID = (a: any, b: any): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            const aName: string = a.ID;
            const bName: string = b.ID;
            return aName > bName ? -1 : aName < bName ? 1 : 0;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.SortDescObjectById");
            return 0;
        }
    };

    public static SortAscObjectByID = (a: any, b: any): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            const aName: any = a.ID;
            const bName: any = b.ID;
            return aName > bName ? 1 : aName < bName ? -1 : 0;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.SortAscObjectByID");
            return 0;
        }
    };
    public static SortObjectById = (a: any, b: any): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            const aName: any = a.id;
            const bName: any = b.id;
            return aName < bName ? -1 : aName > bName ? 1 : 0;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.SortObjectById");
            return 0;
        }
    };
    public static GetIndexFromID = (ID: number, ObjectArray: any[]): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            let CurrObject: any;
            //Finds the index of the id in an object array with IDs
            for (let index = 0; index < ObjectArray.length; index++) {
                CurrObject = ObjectArray[index];
                if (CurrObject.ID === ID) {
                    return index;
                }
            }
            return 0;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "K.kalmstromShared.GetIndexFromID");
            return 0;
        }
    };

    public static ObjectNamesArray = (
        ObjectArray: any[],
        OnlyNonHidden?: boolean
    ): string[] => {
        if (ks.kErrorMode === true) {
            return [];
        }
        try {
            //Gets only the names from an object array into a plain array
            const Results: string[] = [];
            let CurrObject: any = null;
            let CurrVisible = true;
            for (CurrObject of ObjectArray) {
                if (OnlyNonHidden === true) {
                    CurrVisible = true;
                    if (CurrObject.Hide !== undefined) {
                        if (CurrObject.Hide === true) {
                            CurrVisible = false;
                        }
                    }
                    if (CurrVisible) {
                        if (CurrObject.Name !== undefined) {
                            Results.push(CurrObject.Name);
                        } else {
                            Results.push(CurrObject.Title);
                        }
                    }
                } else {
                    if (CurrObject.Name !== undefined) {
                        Results.push(CurrObject.Name);
                    } else {
                        Results.push(CurrObject.Title);
                    }
                }
            }
            return Results;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.ObjectNamesArray");
            return [];
        }
    };
    public static AddOffSet = (Currdate: Date): Date | null => {
        if (ks.kErrorMode === true) {
            return null;
        }
        try {
            return new Date(
                Currdate.getTime() + -1 * Currdate.getTimezoneOffset() * 60000
            );
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.AddOffSet");
            return null;
        }
    };
    public static TruncateText = (
        sourceString: string,
        length: number
    ): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if (
                sourceString === undefined ||
                sourceString === null ||
                sourceString === ""
            )
                return "";
            let truncatedString: string = sourceString.substring(0, length);
            if (sourceString.length > length) truncatedString += "...";
            return truncatedString;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "K.kalmstromShared.TruncateText");
            return "";
        }
    };
    public static EncodeUrl = (url: string): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if (ks.kNotEmptyString(url)) {
                let urlParts: string[] = [];
                let i = 0;
                const fullUrl: string[] = url.split("//");
                if (fullUrl.length > 1) {
                    urlParts = fullUrl[1].split("/");
                } else {
                    urlParts = fullUrl[0].split("/");
                }
                for (i = 0; i < urlParts.length; i++) {
                    if (ks.kNotEmptyString(urlParts[i])) {
                        urlParts[i] = encodeURIComponent(urlParts[i]);
                    }
                }
                url = urlParts.join("/");
                if (fullUrl.length > 1) {
                    url = fullUrl[0] + "//" + url;
                }
                return url;
            } else {
                return "";
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.EncodeUrl");
            return "";
        }
    };
    public static EncodeSpecialCharacter = (stringval: string): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if (stringval !== null && stringval !== "")
                stringval = stringval
                    .replace(/>/g, "&gt;")
                    .replace(/</g, "&lt;")
                    .replace(/"/g, "&quot;")
                    .replace(/\\/g, "&#92;")
                    .replace(/&amp;/g, "&");
            return stringval;
        } catch (e) {
            ks.kGlobalErrorHandler(
                e,
                "K.kalmstromShared.EncodeSpecialCharacter"
            );
            return "";
        }
    };
    public static DecodeSpecialCharacter = (stringval: string): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if (stringval !== null && stringval !== "")
                stringval = stringval
                    .replace(/&gt;/g, ">")
                    .replace(/&lt;/g, "<")
                    .replace(/&quot;/g, '"')
                    .replace(/&#92;/g, "\\")
                    .replace(/&amp;/g, "&");
            return stringval;
        } catch (e) {
            ks.kGlobalErrorHandler(
                e,
                "K.kalmstromShared.DecodeSpecialCharacter"
            );
            return "";
        }
    };
    public static appendQueryString = (
        url: string,
        paramName: string,
        paramValue: string
    ): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            let queryString = "";
            if (
                (typeof paramName === "string" ||
                    typeof paramName === "number") &&
                (typeof paramValue === "string" ||
                    typeof paramValue === "number")
            ) {
                //remove query string parameter if already exists
                url = ks.removeURLParameter(url, paramName);
                const queryStringParts: string[] = [];
                queryStringParts.push(paramName + "=" + paramValue);
                queryString = queryStringParts.join("&");
                if (queryString.length > 0) {
                    const firstSeperator: string =
                        url.indexOf("?") === -1 ? "?" : "&";
                    queryString = firstSeperator + queryString;
                }
            }
            return url + queryString;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.appendQueryString");
            return "";
        }
    };
    public static removeURLParameter = (
        url: string,
        paramName: string
    ): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            const urlparts: string[] = url.split("?");
            if (urlparts.length >= 2) {
                const prefix: string = encodeURIComponent(paramName) + "=";
                const pars: string[] = urlparts[1].split(/[&;]/g);
                //reverse iteration as may be destructive
                for (let i: number = pars.length; i-- > 0; ) {
                    //idiom for string.startsWith
                    if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                        pars.splice(i, 1);
                    }
                }
                url =
                    urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
            }
            return url;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "K.kalmstromShared.removeURLParameter");
            return "";
        }
    };





    public static ValidateValues = (
        cellValue: any,
        DefaultValue: any,
        ValueType: string
    ): void => {
        let Value: any = DefaultValue;
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (ks.kNotNullOrUndefined(cellValue)) {
                if (ValueType === "Int") {
                    if (ks.kNotInteger(cellValue)) {
                        Value = DefaultValue;
                    } else {
                        Value = parseInt(cellValue);
                    }
                } else if (ValueType === "Bool") {
                    Value = ks.parseBool(cellValue);
                } else {
                    Value = cellValue;
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.ValidateValues");
        }
        return Value;
    };

    public static RemoveEndSlash = (str: string): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if (ks.kNotEmptyString(str)) {
                if (str.substring(str.length - 1) === "/") {
                    str = str.substring(0, str.length - 1);
                }
            }
            return str;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.RemoveEndSlash");
            return "";
        }
    };
    // Function to retrieve a query string value.
    public static getQueryStringParameter = (
        paramToRetrieve: string
    ): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            if (document.URL.indexOf("?") > 0) {
                const params: string[] = document.URL.split("?")[1].split("&");
                let singleParam: string[] = [];
                for (let i = 0; i < params.length; i = i + 1) {
                    singleParam = params[i].split("=");
                    if (
                        singleParam[0].toLowerCase() ===
                        paramToRetrieve.toLowerCase()
                    ) {
                        return singleParam[1];
                    }
                }
            } else {
                return "";
            }
            return "";
        } catch (e) {
            ks.kGlobalErrorHandler(
                e,
                "kalmstromShared.getQueryStringParameter"
            );
            return "";
        }
    };

    public static GetQueryParameterByName = (name: string): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            const WholeURL: URL = new URL(document.location.href);
            const Params: URLSearchParams = WholeURL.searchParams;
            return ks.nz(Params.get(name));
        } catch (e) {
            ks.kGlobalErrorHandler(
                e,
                "kalmstromShared.GetQueryParameterByName"
            );
            return "";
        }
    };

    public static GetFullCountryAndRegionFromCountry= (TwoLetterCountryCode:string):string =>{
    
        const code = TwoLetterCountryCode.toLowerCase();

        switch (code) {
            case "af": return "af-ZA";
            case "am": return "am-ET";
            case "ar": return "ar-SA";
            case "az": return "az-AZ";
            case "be": return "be-BY";
            case "bg": return "bg-BG";
            case "bn": return "bn-BD";
            case "bs": return "bs-BA";
            case "ca": return "ca-ES";
            case "cs": return "cs-CZ";
            case "cy": return "cy-GB";
            case "da": return "da-DK";
            case "de": return "de-DE";
            case "el": return "el-GR";
            case "en": return "en-US";
            case "es": return "es-ES";
            case "et": return "et-EE";
            case "eu": return "eu-ES";
            case "fa": return "fa-IR";
            case "fi": return "fi-FI";
            case "fil": return "fil-PH";
            case "fr": return "fr-FR";
            case "gl": return "gl-ES";
            case "gu": return "gu-IN";
            case "he": return "he-IL";
            case "hi": return "hi-IN";
            case "hr": return "hr-HR";
            case "hu": return "hu-HU";
            case "hy": return "hy-AM";
            case "id": return "id-ID";
            case "is": return "is-IS";
            case "it": return "it-IT";
            case "ja": return "ja-JP";
            case "jv": return "jv-ID";
            case "ka": return "ka-GE";
            case "kk": return "kk-KZ";
            case "km": return "km-KH";
            case "kn": return "kn-IN";
            case "ko": return "ko-KR";
            case "lo": return "lo-LA";
            case "lt": return "lt-LT";
            case "lv": return "lv-LV";
            case "mk": return "mk-MK";
            case "ml": return "ml-IN";
            case "mn": return "mn-MN";
            case "mr": return "mr-IN";
            case "ms": return "ms-MY";
            case "nb": return "nb-NO";
            case "ne": return "ne-NP";
            case "nl": return "nl-NL";
            case "no": return "no-NO";
            case "pa": return "pa-IN";
            case "pl": return "pl-PL";
            case "pt": return "pt-PT";
            case "ro": return "ro-RO";
            case "ru": return "ru-RU";
            case "si": return "si-LK";
            case "sk": return "sk-SK";
            case "sl": return "sl-SI";
            case "sq": return "sq-AL";
            case "sr": return "sr-RS";
            case "sv": return "sv-SE";
            case "sw": return "sw-KE";
            case "ta": return "ta-IN";
            case "te": return "te-IN";
            case "th": return "th-TH";
            case "tr": return "tr-TR";
            case "uk": return "uk-UA";
            case "ur": return "ur-PK";
            case "uz": return "uz-UZ";
            case "vi": return "vi-VN";
            case "zh": return "zh-CN";
            case "zh-hant": return "zh-TW"; // Traditional Chinese
            default: return TwoLetterCountryCode; // Return original if not matched
        }
    }
    public static getLocalDataFormat = (CountryCode: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            let TempCurrFormat: any = null;
            CountryCode = CountryCode.toLowerCase();
            if(CountryCode.length === 2){
                CountryCode = ks.GetFullCountryAndRegionFromCountry(CountryCode).toLowerCase();
            }
            for (let i = 0; i < ks._localeDateFormat.length; i++) {
                if (ks._localeDateFormat[i].BC47 === CountryCode) {
                    TempCurrFormat = ks._localeDateFormat[i];
                    //https://stackoverflow.com/questions/27647918/detect-with-javascript-if-users-machine-is-using-12-hour-clock-am-pm-or-24-cl
                    //https://www.webwiz.net/kb/asp-tutorials/date-time-settings.htm
                    if (
                        [
                            3081, 10249, 4105, 9225, 6153, 8201, 5129, 13321,
                            7177, 11273, 2057, 1033, 3084, 1081, 1065, 1097,
                        ].indexOf(TempCurrFormat.LCID) > -1
                    ) {
                        TempCurrFormat.t12 = true;
                    } else {
                        TempCurrFormat.t12 = false;
                    }
                    break;
                }
            }
            ks.NumberandDateFormat = TempCurrFormat;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.getLocalDataFormat");
        }
    };

    public static UserLangeGetInfo = (language?: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (
                language === null ||
                language === "" ||
                language === undefined
            ) {
                ks.UserLanguageLong = navigator.language;
                ks.UserLanguageLong = ks.UserLanguageLong.toLowerCase();
                ks.UserLanguage = ks.UserLanguage.substring(0, 2).toLowerCase();
            } else {
                ks.UserLanguageLong = language.toLowerCase();
                ks.UserLanguage = ks.UserLanguageLong.substring(
                    0,
                    2
                ).toLowerCase();
            }

            //http://stackoverflow.com/questions/1043339/javascript-for-detecting-browser-language-preference

            if (ks.kApplication.LCID === 0) {
                //userLang = "ru";
                switch (ks.UserLanguage) {
                    case "ar":
                        ks.kApplication.LCID = 1030;
                        ks.UserLanguageName = "Arabic";
                        break;
                    case "da":
                        ks.kApplication.LCID = 1030;
                        ks.UserLanguageName = "Danish";
                        break;
                    case "de":
                        ks.kApplication.LCID = 2055;
                        ks.UserLanguageName = "German";
                        break;
                    case "fr":
                        ks.kApplication.LCID = 1036;
                        ks.UserLanguageName = "French";
                        break;
                    case "nl":
                        ks.kApplication.LCID = 2067;
                        ks.UserLanguageName = "Dutch";
                        break;
                    case "no":
                        ks.kApplication.LCID = 1044;
                        ks.UserLanguageName = "Norwegian";
                        break;
                    case "nb":
                        ks.kApplication.LCID = 1044;
                        ks.UserLanguageName = "Norwegian";
                        break;
                    case "pt":
                        ks.kApplication.LCID = 2070;
                        ks.UserLanguageName = "Portuguese";
                        break;
                    case "sv":
                        ks.kApplication.LCID = 1053;
                        ks.UserLanguageName = "Swedish";
                        break;
                    case "it":
                        ks.kApplication.LCID = 1040;
                        ks.UserLanguageName = "Italian";
                        break;
                    case "es":
                        ks.kApplication.LCID = 1034;
                        ks.UserLanguageName = "Spanish";
                        break;
                    default:
                        ks.kApplication.LCID = 1033;
                        break;
                }
            } else {
                //we have a pre-defined LCID
                switch (ks.kApplication.LCID) {
                    case 1030:
                        ks.UserLanguageName = "Danish";
                        break;
                    case 1043:
                    case 2067:
                        ks.UserLanguageName = "Dutch";
                        break;
                    case 1036:
                    case 2060:
                    case 3084:
                    case 5132:
                    case 4108:
                        ks.UserLanguageName = "French";
                        break;
                    case 1031:
                    case 3079:
                    case 5127:
                    case 4103:
                    case 2055:
                        ks.UserLanguageName = "German";
                        break;
                    case 1040:
                    case 2064:
                        ks.UserLanguageName = "Italian";
                        break;
                    case 1046:
                    case 2070:
                        ks.UserLanguageName = "Portuguese";
                        break;
                    case 1044:
                        ks.UserLanguageName = "Norwegian";
                        break;
                    case 3082:
                    case 1034:
                    case 11274:
                    case 16394:
                    case 13322:
                    case 9226:
                    case 5130:
                    case 7178:
                    case 12298:
                    case 4106:
                    case 18442:
                    case 2058:
                    case 19466:
                    case 6154:
                    case 10250:
                    case 20490:
                    case 15370:
                    case 17418:
                    case 14346:
                    case 8202:
                        ks.UserLanguageName = "Spanish";
                        break;
                    case 1053:
                        ks.UserLanguageName = "Swedish";
                        break;
                    case 5121:
                    case 15361:
                    case 3073:
                    case 2049:
                    case 11265:
                    case 13313:
                    case 12289:
                    case 4097:
                    case 6145:
                    case 8193:
                    case 16385:
                    case 1025:
                    case 10241:
                    case 7169:
                    case 14337:
                    case 9217:
                        ks.UserLanguageName = "Arabic";
                        break;
                    default: //English
                        break;
                }
            }
            ks.getLocalDataFormat(ks.UserLanguageLong);
            LNG.SetLanguage(ks.UserLanguageName);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "ks.UserLangeGetInfo");
        }
    };
    public static LocalCurrencyNumber =(Nr:number):string =>{
        if(ks.NumberandDateFormat === null){
            ks.getLocalDataFormat(navigator.language.toLowerCase());
        }
        if(ks.NumberandDateFormat){
            return Nr.toLocaleString(ks.NumberandDateFormat.BC47,{style: "currency","currency":ks.NumberandDateFormat.curr});
        }else{
            return Nr.toString();
        }
    }
    public static NumberFromCurrency =(FormattedNumber:string):number =>{
        if(ks.NumberandDateFormat === null){
            ks.getLocalDataFormat(navigator.language.toLowerCase());
        }
        if(ks.NumberandDateFormat){
            const Zero:number = 0;
            const FormattedZero:string =Zero.toLocaleString(ks.NumberandDateFormat.BC47,{style: "currency","currency":ks.NumberandDateFormat.curr}) ;
            const CurrencySymbol = FormattedZero.replace("0","").replace(".00","").replace(",00","");
            let NumberString:string ="";
            if(typeof(FormattedNumber) === "string"){
                NumberString = FormattedNumber.replace(CurrencySymbol,"");
            }else{
                NumberString = ks.nz(FormattedNumber);
            }
            return ks.n0(NumberString);    
        }else{
            return 0;
        }
    }
    public static SetCaptions = (CallBack?: any, language?: string): void => {
        let 
            CurrElement: HTMLElement,
            strCurrCaption = "",
            strNewCaption = "",
            i = 0,
            blnValue = false,
            blnTitle = false,
            blnAtt = false,
            prefixword = "",
            trimwords = "";
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            ks.kStartTimer("K.kalmstromShared.SetCaptions");
            if (window.Phrases.length === 0) {
                ks.UserLangeGetInfo(language);
            }
            const TranslatableElements:HTMLCollectionOf<HTMLElement> = document.getElementsByClassName("translatable") as HTMLCollectionOf<HTMLElement>;
            if (TranslatableElements .length > 0) {
                for (i; i < TranslatableElements.length; i += 1) {
                    blnValue = false;
                    blnTitle = false;
                    blnAtt = false;
                    CurrElement = TranslatableElements[i];

                    if (CurrElement.tagName === "IMG") {
                        strCurrCaption = ks.nz(CurrElement.getAttribute("alt"));
                        prefixword = strCurrCaption.substring(0, 3);
                        if (prefixword === "LNG") {
                            // eslint-disable-next-line no-eval
                            strNewCaption = eval(strCurrCaption + "();");
                            CurrElement.setAttribute("alt", strNewCaption);
                        }
                        strCurrCaption = CurrElement.title;
                        prefixword = strCurrCaption.substring(0, 3);
                        if (prefixword === "LNG") {
                            // eslint-disable-next-line no-eval
                            strNewCaption = eval(strCurrCaption + "();");
                            CurrElement.title = strNewCaption;
                        }
                        CurrElement.style.display = "block";
                    } else {
                        strCurrCaption = ks.nz(CurrElement.textContent);
                        if (ks.kNotEmptyString(strCurrCaption)) {
                            strCurrCaption = strCurrCaption.trim();
                        }
                        if (strCurrCaption === "") {
                            strCurrCaption = ks.nz(CurrElement.getAttribute("value"));
                            if (ks.kNotEmptyString(strCurrCaption)) {
                                blnValue = true;
                            } else {
                                strCurrCaption = CurrElement.title;
                                if (ks.kNotEmptyString(strCurrCaption)) {
                                    blnTitle = true;
                                } else {
                                    strCurrCaption = CurrElement.title;
                                    if (ks.kNotEmptyString(strCurrCaption)) {
                                        blnAtt = true;
                                    }
                                }
                            }
                        }
                        if (strCurrCaption !== "") {
                            //Trim words before take actual meaning. Condition apply by sharad verma on 09 Oct 2013
                            trimwords = strCurrCaption.trim();
                            prefixword = trimwords.substring(0, 3);
                            if (prefixword === "LNG") {
                                // eslint-disable-next-line no-eval
                                strNewCaption = eval(strCurrCaption + "();");
                                if (blnTitle === true) {
                                    CurrElement.title = strNewCaption;
                                    CurrElement.style.display = "block";
                                } else if (blnValue === true) {
                                    CurrElement.setAttribute("value", strNewCaption);
                                    CurrElement.style.display = "block";
                                } else if (blnAtt === true) {
                                    CurrElement.title =  strNewCaption;
                                    CurrElement.style.display = "block";
                                } else {
                                    CurrElement.textContent = strNewCaption;
                                    CurrElement.style.display = "block";
                                }
                            }
                        }
                    }
                }
            }
            ks.kEndTimer("K.kalmstromShared.SetCaptions");
            if (typeof CallBack === "function") {
                window.setTimeout(CallBack, 10);
            }
        } catch (e) {
            //alert(LastTagName);
            ks.kGlobalErrorHandler(
                e,
                "K.kalmstromShared.SetCaptions " + strCurrCaption
            );
        }
    };

    //Local storage

    public static LocalStorageStore = (key: string, data: any): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            // If using a modern browser, lets use localStorage and avoid the overhead
            // of a cookie
            if (ks.IsLocalStorageWorking()) {
                data = data.toString();
                const Parts: number = Math.ceil(
                    data.length / ks.LocalStorageLimit
                );
                ks.LocalStorageClear(key);
                localStorage[key + "_Count"] = Parts;
                for (let part = 0; part <= Parts - 1; part++) {
                    const StartLen: number = part * ks.LocalStorageLimit;
                    let EndLen: number = StartLen + ks.LocalStorageLimit;
                    if (EndLen > data.length) {
                        EndLen = data.length;
                    }
                    //EndLen = EndLen - StartLen;
                    const partDate: string = data.substring(StartLen, EndLen);
                    localStorage[key + part] = partDate;
                }
            }
            // commented cookies fallback because it support very limiter amount of data
            // Otherwise we need to store data in a cookie, not quite so eloquent.
            else {
                const JSONlength: number = data.toString().length;
                if (JSONlength < 1000) {
                    ks.createCookie(key, data, 1000);
                }
            }
        } catch (e) {
            //K.kalmstromShared.kGlobalErrorHandler(e, "kalmstromShared.LocalStorage.Store"); ignore error if not able to cache data
        }
    };
    public static LocaleStorageLoad = (key: string): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            let data = "";
            let curData: string;
            // // If using localStorage, retrieve from there
            if (ks.IsLocalStorageWorking()) {
                const Parts: number = localStorage[key + "_Count"];
                if (ks.kNotNullOrUndefined(Parts)) {
                    for (let part = 0; part <= Parts - 1; part++) {
                        curData = localStorage[key + part];
                        if (ks.kNotEmptyString(curData)) {
                            data = data + curData;
                        }
                    }
                }
            }
            // Otherwise we have to use cookie based storage
            else {
                //return ""; // commented cookies fallback because it support very limiter amount of data
                data = ks.readCookie(key);
                if (data.toString().length >= 1000) {
                    return "";
                } else {
                    return data;
                }
            }

            // If we have data, lets turn it into an object, otherwise return false
            if (data) {
                return data;
            }
            return "";
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.LocaleStorageLoad");
            return "";
        }
    };
    public static LocalStorageClear = (key: string): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            if (typeof localStorage !== "undefined" && localStorage !== null) {
                localStorage[key] = "";
                const Parts: number = localStorage[key + "_Count"];
                localStorage[key + "_Count"] = 0;
                if (ks.kNotNullOrUndefined(Parts)) {
                    for (let part = 0; part <= Parts - 1; part++) {
                        localStorage[key + part] = "";
                    }
                }
            }
        } catch (e) {
            //Not throwing error intentionally
        }
    };
    public static IsLocalStorageWorking = (): boolean => {
        if (ks.kErrorMode === true) {
            return false;
        }
        try {
            let localStorageWorks = false;
            try {
                if (
                    typeof localStorage !== "undefined" &&
                    localStorage !== null
                ) {
                    const testKey = "test",
                        storage: Storage = localStorage;

                    storage.setItem(testKey, "1");
                    storage.removeItem(testKey);
                    localStorageWorks = true;
                }
            } catch (error) {
                //local storage doesn't work
            }
            return localStorageWorks;
        } catch (e) {
            ks.kGlobalErrorHandler(
                e,
                "kalmstromShared.LocalStorage.IsLocalStorageWorking"
            );
            return false;
        }
    };
    public static NewGuid = (): string => {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (c) {
                const r = (Math.random() * 16) | 0,
                    v = c === "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            }
        );
    };
    //Cookies
    public static createCookie = (
        name: string,
        value: string,
        days: number
    ): void => {
        let expires = "",
            date: Date;
        if (days) {
            date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    };
    public static readCookie = (name: string): string => {
        let nameEQ = "",
            ca: string[] = [],
            i = 0,
            c = "";
        nameEQ = name + "=";
        ca = document.cookie.split(";");
        for (i; i < ca.length; i += 1) {
            c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return "";
    };
    public static eraseCookie = (name: string): void => {
        ks.createCookie(name, "", -1);
    };

    public static getRandomInt = (min: number, max: number): number => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    //Gets's the next not already used color
    public static StandardColors:Array<string> =  ["255,255,128","0,128,255","192,192,192","25,216,206","128,128,255","255,128,255","128,128,64","242,198,99","128,0,255","255,128,128","37,251,160","9,28,195","108,202,68","104,104,104","255,0,0","0,255,0","0,0,255","255,165,0","255,20,147","75,0,130","255,215,0","0,206,209","50,205,50","220,20,60","244,164,96","123,104,238","127,255,212","210,105,30","255,69,0","34,139,34","255,99,71","0,191,255","186,85,211","255,140,0","46,139,87","147,112,219","60,179,113","205,92,92","218,165,32","199,21,133","135,206,235","72,61,139","176,196,222","244,164,176","139,0,0","0,100,0","25,25,112","240,230,140","255,182,193","112,128,144"];

    // Modern color palette for charts with better contrast and visual appeal
    public static ModernChartColors:Array<string> = ["54,162,235","255,99,132","75,192,192","255,206,86","153,102,255","255,159,64","46,204,113","231,76,60","52,152,219","155,89,182","241,196,15","26,188,156","230,126,34","149,165,166","52,73,94","236,240,241"];

    public static GetNextColor = (ArrayWithColors: any[]): string => {
        let Item:any = null;
        let CurrColor:string = "";
        let StColor:string = "";
        let intUsedColors:number = 0;
        if (ks.kErrorMode === true) {
            return "";
        }
        try {

            let CountItems = 0;
            let CountColors = 0;
            for (
                CountItems = 0;
                CountItems < ArrayWithColors.length;
                CountItems++
            ) {
                Item = ArrayWithColors[CountItems];
                CurrColor = Item.Color;
                CurrColor = CurrColor.replace("rgb(","");
                CurrColor = CurrColor.replace(")","");
                if (CurrColor !== "") {
                    CurrColor = ks.replaceAll(", ", ",", CurrColor);
                    for (
                        CountColors = 0;
                        CountColors < ks.StandardColors.length;
                        CountColors++
                    ) {
                        StColor = ks.StandardColors[CountColors];
                        if (CurrColor === StColor) {
                            if (CountColors > intUsedColors) {
                                intUsedColors = CountColors;
                            }
                        }
                    }
                }
            }
            if (intUsedColors < ks.StandardColors.length - 1) {
                return ks.StandardColors[intUsedColors + 1];
            } else {
                return (
                    Math.floor(Math.random() * 255) +
                    "," +
                    Math.floor(Math.random() * 255) +
                    "," +
                    Math.floor(Math.random() * 255)
                );
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "K.kalmstromShared.GetNextColor");
            return "";
        }
    };
    public static GetNextHexColor = (ArrayWithColors: any[]): string => {
        if (ks.kErrorMode === true) {return "";}
        let Item: any = null;
        let CurrColor = "",
            StColor = "";
        let intUsedColors = -1;
        const StandardColors: string[] = [
            "#CFCFC4",
            "#AECACF",
            "#F5F5F5",
            "#FFDFC9",
            "#FFEFD5",
            "#FFDEAD",
            "#EBFFF5",
            "#B6C8E0",
            "#D2BEBE",
            "#C4C3D0",
            "#A9BA9D",
            "#ABCDEF",
            "#FFF5FF",
        ];
        let CountItems = 0;
        let CountColors = 0;
        try {

            for (
                CountItems = 0;
                CountItems < ArrayWithColors.length;
                CountItems++
            ) {
                Item = ArrayWithColors[CountItems];
                CurrColor = ks.nz(Item.Color);
                if (CurrColor !== "") {
                    CurrColor = ks.replaceAll(", ", ",", CurrColor);
                    CurrColor = CurrColor.toUpperCase();
                    for (
                        CountColors = 0;
                        CountColors < StandardColors.length;
                        CountColors++
                    ) {
                        StColor = StandardColors[CountColors];
                        if (CurrColor === StColor) {
                            if (CountColors > intUsedColors) {
                                intUsedColors = CountColors;
                            }
                        }
                    }
                }
            }
            if (intUsedColors < StandardColors.length - 1) {
                return StandardColors[intUsedColors + 1];
            } else {
                return "#" + ((Math.random() * 0xffffff) << 0).toString(16);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.GetNextHexColor");
            return "";
        }
    };

    // Methods for converting RGB to HEX
    public static getRGBCodeFromHex = (HexColorCode: string): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            let RGB: string = ks.hexToR(HexColorCode).toString();
            RGB = RGB + "," + ks.hexToG(HexColorCode).toString();
            RGB = RGB + "," + ks.hexToB(HexColorCode).toString();
            //Returning RGB color code string
            return RGB;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "K.kalmstromShared.getRGBCodeFromHex");
            return "";
        }
    };

    public static getRGB = (color: string): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            const R: number = ks.hexToR(color);
            const G: number = ks.hexToG(color);
            const B: number = ks.hexToB(color);
            return ks.getRawColor(R, G, B);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "getRGB");
            return "";
        }
    };
    public static hexToR = (h: string): number => {
        return parseInt(ks.cutHex(h).substring(0, 2), 16);
    };
    public static hexToG = (h: string): number => {
        return parseInt(ks.cutHex(h).substring(2, 4), 16);
    };
    public static hexToB = (h: string): number => {
        return parseInt(ks.cutHex(h).substring(4, 6), 16);
    };
    public static cutHex = (h: string): string => {
        return h.charAt(0) === "#" ? h.substring(1, 7) : h;
    };
    public static getRawColor = (R: number, G: number, B: number): any => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            let rgb: number = R;
            rgb = (rgb << 8) + G;
            rgb = (rgb << 8) + B;
            return rgb;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "getRawColor");
        }
    };

    public static SetCaptionColorStyle = (
        ColorCode: string,
        Important?: boolean
    ): string => {
        //Returns the proper font color depending on the background lightness
        let r = 0,
            g = 0,
            b = 0,
            Parts: string[] = [],
            strColor = "",
            yiq = 0;
        if (ks.kErrorMode === true) {
            return "";
        }
        let NewColorCode:string = "";
        try {
            NewColorCode = ColorCode;
            if (ColorCode.indexOf("#") > -1) {
                NewColorCode = ks.getRGBCodeFromHex(ColorCode);
            }else{
                if(ColorCode.indexOf("rgb") > -1){
                    NewColorCode =ColorCode.replace("rgb(", "").replace(")", "");
                }
            }
            Parts = NewColorCode.split(",");
            r = parseInt(Parts[0], 10);
            g = parseInt(Parts[1], 10);
            b = parseInt(Parts[2], 10);
            yiq = (r * 299 + g * 587 + b * 114) / 1000;
            strColor = yiq >= 128 ? "black" : "white";
            if (Important !== false) {
                strColor += "!important";
            }
            return strColor;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "ks.CaptionColorStyle");
            return "";
        }
    };

    public static GetInitials = (str: string, initialCount = 2): string => {
        if (ks.kErrorMode === true) {
            return "";
        }
        try {
            let initials = "";
            if (ks.kNotNullOrUndefined(str)) {
                const varParts: string[] = str.split(" ");
                const strCount: number = varParts.length;
                if (strCount < initialCount) {
                    initialCount = strCount;
                }
                for (let i = 0; i < initialCount; i++) {
                    initials += varParts[i].substring(0, 1);
                }
            }
            if(initials === ""){
                initials = str.substring(0,1);
            }
            return initials.toUpperCase();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kalmstromShared.GetInitials");
            return "";
        }
    };
    public static parseBool = (str: any): boolean => {
        if (str === null) return false;
        if (typeof str === "boolean") {
            return str === true;
        }
        if (typeof str === "string") {
            if (str === "") return false;
            str = str.replace(/^\s+|\s+$/g, "");
            if (
                str.toLowerCase() === "true" ||
                str.toLowerCase() === "yes" ||
                str.toLowerCase() === 1
            )
                return true;
            str = str.replace(/,/g, ".");
            // eslint-disable-next-line no-useless-escape
            str = str.replace(/^\s*\-\s*/g, "-");
        }
        if (!isNaN(str)) return parseFloat(str) !== 0;
        return false;
    };
    public static roundToTwo = (num: number): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            let negative = false;
            if (num < 0) {
                negative = true;
                num = num * -1;
            }
            const multiplicator: number = Math.pow(10, 2);
            num = parseFloat((num * multiplicator).toFixed(11));
            num = parseFloat((Math.round(num) / multiplicator).toFixed(2));
            if (negative) {
                num = parseFloat((num * -1).toFixed(2));
            }
            return num;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "K.kalmstromShared.roundToTwo");
            return 0;
        }
    };

    public static getImageSizeInBytes = (imgURL: string): number => {
        if (ks.kErrorMode === true) {
            return 0;
        }
        try {
            const request: XMLHttpRequest = new XMLHttpRequest();
            request.open("HEAD", imgURL, false);
            request.send(null);
            const headerText: string = request.getAllResponseHeaders();
            // eslint-disable-next-line no-useless-escape
            const re = /Content\-Length\s*:\s*(\d+)/i;
            re.exec(headerText);

            return parseInt(RegExp.$1, 10);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "K.kalmstromShared.getImageSizeInBytes");
            return 0;
        }
    };



    public static AddDelayedAction = (
        NewCategory: string,
        CallBack: any,
        Comment?: string,
        MSDelay?: number,
        Params?: any
    ): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            const CurrAction: kDelayedAction = new kDelayedAction();
            CurrAction.Category = NewCategory;

            CurrAction.Description = ks.nz(Comment);
            if (ks.kNotNullOrUndefined(Params)) {
                CurrAction.Parameters = Params;
            } else {
                CurrAction.Parameters = null;
            }
            CurrAction.CallBack = CallBack;
            ks.kDelayedActions.push(CurrAction);
            CurrAction.ID = ks.getRandomInt(1, 100000);
            CurrAction.MSSecondsDelay = ks.n0(MSDelay);
            if (CurrAction.MSSecondsDelay !== 0) {
                window.setTimeout(ks.DoActions, MSDelay, CurrAction.ID,Params);
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "K.kalmstromShared.AddDelayedAction");
        }
    };

    public static DoActions = (CategoryOrID: any,MakeNull?:boolean): void => {
        if (ks.kErrorMode === true) {
            return;
        }
        try {
            let CurrAction: kDelayedAction,
                Counter = 0;
            let ArrayLength = 0;
            if (!ks.kNotNullOrUndefined(CategoryOrID)) {
                CategoryOrID = "Delay";
            }
            ArrayLength = ks.kDelayedActions.length - 1;
            for (Counter = ArrayLength; Counter > -1; Counter--) {
                CurrAction = ks.kDelayedActions[Counter];
                if (ks.kNotNullOrUndefined(CurrAction)) {
                    if (
                        CurrAction.Category === CategoryOrID.toString() ||
                        CurrAction.ID === CategoryOrID
                    ) {
                        if (typeof CurrAction.CallBack === "function") {
                            if (CurrAction.Enabled === true) {
                                //CurrAction.Enabled = false; //This is if the DoAction happens again while the previous callback is still running.
                                //console.log(Counter + " removing task " + CurrAction.Description);
                                if(MakeNull!==false){
                                    ks.kDelayedActions.splice(Counter, 1);
                                }
                                if (CurrAction.Parameters !== null) {
                                    CurrAction.CallBack(CurrAction.Parameters);
                                } else {
                                    CurrAction.CallBack();
                                }
                            }
                        }
                    }
                }
            }
        } catch (e) {
            ks.kGlobalErrorHandler(
                e,
                "K.kalmstromShared.DoActions",
                CategoryOrID
            );
        }
    };

    public static ShowNotification = (Message: string, AutoCloseDelay?: number, IsWarning?: boolean): void => {
        if (ks.kErrorMode === true) {return;}
        try {
            window.setTimeout(kNotification.ShowNew, 10, Message, IsWarning === true); //DoEvents
        } catch (e) {ks.kGlobalErrorHandler(e, "K.kalmstromShared.ShowNotification");
        }
    };
    public static copyToClipboard=async (textToCopy:string):Promise<void> => {
        if (ks.kErrorMode === true) {return;}
        try {
            // Navigator clipboard api needs a secure context (https)
            const MyNav:any = navigator as any;
            if (MyNav.clipboard && window.isSecureContext) {
                await MyNav.clipboard.writeText(textToCopy);
            } else {
                // Use the 'out of viewport hidden text area' trick
                const textArea:HTMLTextAreaElement = document.createElement("textarea");
                textArea.value = textToCopy;
                    
                // Move textarea out of the viewport so it's not visible
                textArea.style.position = "absolute";
                textArea.style.left = "-999999px";
                    
                document.body.appendChild(textArea);
                textArea.select();

                document.execCommand('copy');
                textArea.remove();
            }
        } catch (e) {
            ks.kGlobalErrorHandler(e, "K.kalmstromShared.copyToClipboard");
        }
    }

}




export class kAjaxTest{
    public static Test = ():void =>{
        if (ks.kErrorMode === true) { return; }
        try {
            const kReq:kRequest = new kRequest();
            kReq.Call("https://jsonplaceholder.typicode.com/todos/1","GET",kAjaxTest.ResponseCallBack);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kAjaxTest.Test");
        }
    }
    public static ResponseCallBack = (Response:any):void =>{
        if (ks.kErrorMode === true) { return; }
        try {
            console.log(Response);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "kAjaxTest.ResponseCallBack");
        }
    }
}
declare global {
    interface Window {
        ks: any;
        kNotification: any;
        kModalDialog:any;
        kAjaxTest:any;
    }
}

// import jq37 from "../ReUsableTS/jquery-3.7.1.min.js";


// if(undefined === ks.$ || null === ks.$){
//     const ks$ =(jq37 as any).noConflict(true);
//     ks.$ = ks$;
//     (window as any).JQXLite = ks$;
// }
if(ks){
    window.KDebug.ks = ks;
}

// Register ks as the error handler for kalmstromCore data classes so that
// kObject, kObjectArray, kTime etc. respect ks.kErrorMode and route errors
// through ks.kGlobalErrorHandler when running in the browser.
SetCoreUtils(ks as any as ICoreUtils);


 
